var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-chat-bot",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-chat-bot:not(.animated) .animable {opacity: 0;}svg#freepik_stories-chat-bot.animated #freepik--speech-bubble-2--inject-63 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-chat-bot.animated #freepik--speech-bubble-1--inject-63 {animation: 6s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-chat-bot.animated #freepik--Text--inject-63 {animation: 6s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-63",
    className: "animable",
    style: {
      transformOrigin: "250px 349.8px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-63",
    cx: 250,
    cy: 349.8,
    rx: 242.95,
    ry: 141.68,
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250px 349.8px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-63",
    className: "animable",
    style: {
      transformOrigin: "234.854px 415.184px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-63",
    d: "M180.15,360.71,20.86,452.61c-1.75,1-1.75,2.65,0,3.66l23.4,13.48a7,7,0,0,0,6.34,0l159.29-91.91c1.75-1,1.75-2.65,0-3.66L186.48,360.7A7,7,0,0,0,180.15,360.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "115.375px 415.229px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-63",
    cx: 379.59,
    cy: 400.61,
    rx: 70.57,
    ry: 40.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "379.59px 400.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-63",
    className: "animable",
    style: {
      transformOrigin: "116px 246.553px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mobile--inject-63",
    className: "animable",
    style: {
      transformOrigin: "116px 246.553px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.61,366.42V47.88c0-8.19-4.07-10.45-7.68-12.54S180.36,32,175.22,35L43.69,110.9c-5.14,3-9.31,10.18-9.31,16.11V445.55c0,5.93,3.73,9.43,7.34,11.51s9.92,4.38,15.06,1.42l131.53-76A17.48,17.48,0,0,0,197.61,366.42Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "116px 246.553px"
    },
    id: "el9ndq3ues0dq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.25,369.44,54,447.53l0-319.92-16.92-9.77A19,19,0,0,0,34.38,127V445.55c0,5.93,3.73,9.43,7.34,11.51s9.92,4.38,15.06,1.42l131.53-76a17.76,17.76,0,0,0,8.06-9l-.53-.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.375px 288.865px"
    },
    id: "elkwp00vhof2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.07,45.13,56.16,121.3a14.45,14.45,0,0,0-6.54,11.3V448.54c0,6.37,4.53,9,10,5.79L188.07,380.2a16.4,16.4,0,0,0,7.4-12.81V49.4C195.47,44.7,192.14,42.78,188.07,45.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "122.545px 249.913px"
    },
    id: "elj0dy215ov1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,64.5V359.84A15.58,15.58,0,0,1,182,372L63.08,440.69c-3.87,2.25-7,.44-7-4.05V139.13A15.71,15.71,0,0,1,61,128.53l.67-.6a11.53,11.53,0,0,1,1.42-1l33.45-19.32,2.18-1.25c1.21-.7,2.18-.14,2.18,1.25s1,1.92,2.34,1.17l39-22.5a5,5,0,0,0,2.33-3.86,4.94,4.94,0,0,1,2-3.65l.23-.14,32.72-18.88.7-.41C185,56.54,189,58.85,189,64.5Z",
    id: "el0k6iwud98p68",
    className: "animable",
    style: {
      transformOrigin: "122.54px 249.903px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.8,364.14a15.54,15.54,0,0,0,7-12.18V60.13l-32.1,18.53-.23.14a4.94,4.94,0,0,0-2,3.65,5,5,0,0,1-2.33,3.86l-39,22.5c-1.29.75-2.34.22-2.34-1.17s-1-2-2.18-1.25l-2.18,1.25L63.08,127a11.53,11.53,0,0,0-1.42,1l-.67.6a15.71,15.71,0,0,0-4.93,10.6V431Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "117.43px 245.565px"
    },
    id: "elryvcf8gm3s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.14,96.93,127,86.61c1.07-.62,1.93-.18,1.93,1A4.14,4.14,0,0,1,127,90.79l-17.87,10.32c-1.06.61-1.93.18-1.93-1A4.14,4.14,0,0,1,109.14,96.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.065px 93.8578px"
    },
    id: "eljkgadnj0f5b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.18,80.47c1.2-.7,2.18-.13,2.18,1.25a4.81,4.81,0,0,1-2.18,3.77c-1.2.69-2.17.13-2.17-1.26A4.8,4.8,0,0,1,136.18,80.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "136.185px 82.9777px"
    },
    id: "elqgx63n9t0tc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.59,165.22A7.85,7.85,0,0,0,43.15,159a2.28,2.28,0,0,0-2.36-.2c-.43.26-2.13,1.21-2.58,1.48a2.7,2.7,0,0,0-1.06,2.44v26a7.85,7.85,0,0,0,3.44,6.22,2.3,2.3,0,0,0,2.27.24c.48-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.07-2.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "41.8702px 176.968px"
    },
    id: "elxtb84v1fz5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,166.7v26c0,2.34-1.54,3.35-3.44,2.25a7.85,7.85,0,0,1-3.44-6.22v-26c0-2.34,1.54-3.34,3.44-2.25A7.86,7.86,0,0,1,44,166.7Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "40.56px 177.717px"
    },
    id: "elw06kwyr0i2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.59,210.65a7.86,7.86,0,0,0-3.44-6.22,2.3,2.3,0,0,0-2.36-.19c-.43.26-2.13,1.21-2.58,1.48a2.7,2.7,0,0,0-1.06,2.44v26a7.86,7.86,0,0,0,3.44,6.22,2.33,2.33,0,0,0,2.27.24c.48-.25,2.21-1.25,2.66-1.52a2.68,2.68,0,0,0,1.07-2.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "41.8702px 222.405px"
    },
    id: "elvg0iggejoej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,212.13v26c0,2.34-1.54,3.35-3.44,2.25a7.86,7.86,0,0,1-3.44-6.22v-26c0-2.34,1.54-3.35,3.44-2.25A7.86,7.86,0,0,1,44,212.13Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "40.56px 223.145px"
    },
    id: "el2fb296atzqm",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-63",
    className: "animable",
    style: {
      transformOrigin: "148.335px 269.144px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-63",
    className: "animable",
    style: {
      transformOrigin: "148.335px 269.144px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,74.44c-1.63-.94-3.88-.81-6.36.62l-.71.42L171.72,94.65a1.42,1.42,0,0,0-.23.14,5,5,0,0,0-2,3.71,5.08,5.08,0,0,1-2.37,3.91l-39.57,22.84-.09,0a1.51,1.51,0,0,0-.65-1.35l-2.28-1.32a1.56,1.56,0,0,0-1.56.16l-2.22,1.28-33.95,19.6a13.3,13.3,0,0,0-1.45,1l-.68.61a16,16,0,0,0-5,10.76V458c0,2.27.79,3.86,2.08,4.6l2.3,1.33c1.29.75,3.07.64,5-.5l120.72-69.7A15.82,15.82,0,0,0,217,381.4V81.59c0-2.86-1-4.87-2.64-5.82Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "148.335px 269.123px"
    },
    id: "el8hefei0x8eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2x83usz6iuy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.78,462.49v.59l-.68.39c-2,1.14-3.74,1.25-5,.51l-2.3-1.33c-1.29-.75-2.08-2.34-2.08-4.61V156a14.85,14.85,0,0,1,2.46-7.62L84.87,150a14.45,14.45,0,0,0-2.39,7.37v302a5.52,5.52,0,0,0,1,3.44A3,3,0,0,0,85.91,464a6,6,0,0,0,2.94-.92Z",
    style: {
      opacity: 0.3,
      transformOrigin: "84.75px 306.415px"
    },
    className: "animable",
    id: "elpanbmj3miai"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elc79nl814ann"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.13,97.5a4.18,4.18,0,0,0-.83,2.31,5.07,5.07,0,0,1-.88,2.65l-2.74-1.58a4.54,4.54,0,0,0,.83-2.39,4.8,4.8,0,0,1,.89-2.57Z",
    style: {
      opacity: 0.3,
      transformOrigin: "170.905px 99.19px"
    },
    className: "animable",
    id: "eln7f44s1jija"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.91,463.94a3,3,0,0,1-2.45-1.14,5.52,5.52,0,0,1-1-3.44v-302A15.49,15.49,0,0,1,87.33,147l.21-.19.45-.4a9.83,9.83,0,0,1,1.37-.94l34-19.61,2.22-1.27a1.49,1.49,0,0,1,.74-.24c.64,0,.71.75.71,1.07a1.82,1.82,0,0,0,1.76,2.05,2.68,2.68,0,0,0,1.37-.42l39.57-22.84a5.56,5.56,0,0,0,2.62-4.36,4.51,4.51,0,0,1,1.77-3.29,1.18,1.18,0,0,1,.19-.11l33.21-19.17.71-.42a7.69,7.69,0,0,1,3.76-1.16c2.78,0,4.51,2.28,4.51,5.93V381.4a15.22,15.22,0,0,1-6.88,11.93L88.85,463A6,6,0,0,1,85.91,463.94Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "149.477px 269.821px"
    },
    id: "elvd6eo9r3j5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.94,76.17h0c2.51,0,4,2,4,5.42V381.4a14.89,14.89,0,0,1-6.62,11.49L88.59,462.59a5.56,5.56,0,0,1-2.68.85c-1.83,0-2.92-1.53-2.92-4.08v-302a14.92,14.92,0,0,1,4.67-10l.23-.22.39-.35a11.26,11.26,0,0,1,1.33-.91l34-19.61,2.21-1.27a1.06,1.06,0,0,1,.49-.17c.2,0,.2.51.2.56a2.31,2.31,0,0,0,2.27,2.55,3.21,3.21,0,0,0,1.62-.48l39.57-22.84a6.11,6.11,0,0,0,2.88-4.8,4,4,0,0,1,1.55-2.88l.15-.09,33.22-19.17.7-.41a7.28,7.28,0,0,1,3.51-1.09m0-1a8.14,8.14,0,0,0-4,1.22l-.71.42L174,96a1.35,1.35,0,0,0-.22.14,5,5,0,0,0-2,3.7,5.1,5.1,0,0,1-2.36,3.92l-39.58,22.84a2.19,2.19,0,0,1-1.11.35c-.75,0-1.25-.56-1.25-1.54s-.5-1.58-1.22-1.58a2,2,0,0,0-1,.31l-2.21,1.27L89.11,145a11.37,11.37,0,0,0-1.46,1l-.67.61a16,16,0,0,0-5,10.75v302c0,3.22,1.61,5.09,3.94,5.09a6.55,6.55,0,0,0,3.2-1l120.72-69.7A15.82,15.82,0,0,0,217,381.4V81.59c0-4.07-2.05-6.43-5-6.43Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "149.49px 269.805px"
    },
    id: "elym18gowmo7j",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-63",
    className: "animable",
    style: {
      transformOrigin: "201.574px 266.852px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--robot--inject-63",
    className: "animable",
    style: {
      transformOrigin: "201.574px 266.852px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.75,259a4.52,4.52,0,0,0-1.75-.09,10.5,10.5,0,0,0-7.6,5.7c-.8,1.9-.37,3.42.94,4.07a2.52,2.52,0,0,0,.33.14c16.05,6.76,41.16,6.09,64.43-16.72l-8.4-8.58C261.31,260.52,243.22,262.7,230.75,259Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.048px 258.04px"
    },
    id: "eljflor802can",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.11,249.35a2.49,2.49,0,0,1-.89,2.23A14.77,14.77,0,0,1,287.06,253a2.5,2.5,0,0,1,2.51-4.33,9.85,9.85,0,0,0,11.46-.94,2.51,2.51,0,0,1,4.08,1.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "295.471px 251.131px"
    },
    id: "elx96c9bvhpi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.9,
    cy: 247.76,
    r: 11.54,
    style: {
      fill: "#3293C4",
      transformOrigin: "282.9px 247.76px"
    },
    id: "ele599sqsacm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1qqtf3rf1vk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.25,238.13c1.69,1.27,3.88,7.17-1,11.83-5.68,5.38-15.93,2.27-16.7-4a11.54,11.54,0,1,0,17.74-7.83Z",
    style: {
      opacity: 0.2,
      transformOrigin: "282.947px 248.72px"
    },
    className: "animable",
    id: "elj2a5ve1i8x8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eledaejpp2fin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.43,241.84a2.1,2.1,0,0,0-.22.3,6.52,6.52,0,0,0-.89,1.93,3.94,3.94,0,0,0-.13,2.35,1.69,1.69,0,0,0,1.92,1.17c.77-.24,1.1-1.12,1.35-1.88a30.19,30.19,0,0,1,2.55-5.65.76.76,0,0,0,.14-.59c-.09-.26-.43-.32-.71-.31C276.79,239.27,275.51,240.59,274.43,241.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "276.116px 243.388px"
    },
    className: "animable",
    id: "elbmu9pw2gi3t"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.12,229.26a2.5,2.5,0,0,1-1.91,2.73,9.85,9.85,0,0,0-7.71,8.54,2.5,2.5,0,0,1-5-.63,14.77,14.77,0,0,1,11.55-12.78,2.44,2.44,0,0,1,3,2.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "287.809px 234.891px"
    },
    id: "eldnjj3z7yh0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82,247.73c0,43,18.91,132.78,63.6,132.78S242,290.68,242,247.73Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "178.41px 314.12px"
    },
    id: "el0l51wjfulhqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzj6scgom4p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.82,247.73c0,43,18.91,132.78,63.6,132.78S242,290.68,242,247.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "178.41px 314.12px"
    },
    className: "animable",
    id: "elg80zf3gqvye"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242,247.73c-1.8,25.89-8.91,43.48-20.13,49.7-4.7,2.6-11.3,2.6-17,0-9.55-4.44-16.06-15.12-17.07-20.22l-2.45.49c1.13,5.73,8.07,17.17,18.46,22a28.17,28.17,0,0,0,10.67,2.19,17.57,17.57,0,0,0,8.59-2.22c7.7-4.27,13.56-13.34,17.28-26.37a217.41,217.41,0,0,0,1.7-25.52Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "213.7px 274.81px"
    },
    id: "el3ld2gwd1tre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.39,272c0,44.9-7.41,78.48-22.07,100.36a51.47,51.47,0,0,0,5.33-4.88c12.45-22.17,18.74-54.08,18.74-95.48Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "212.355px 322.18px"
    },
    id: "elhd55ww3f9kc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9eb2xt9xbjg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.21,362.41c-19.41-17.58-23.1-69-17.62-80.19V247.73H114.82c0,43,18.91,132.78,63.6,132.78,15,0,27.1-10.14,36.55-25.23C215,355.29,193.61,380,174.21,362.41Z",
    style: {
      fill: "#3293C4",
      opacity: 0.2,
      transformOrigin: "164.895px 314.12px"
    },
    className: "animable",
    id: "elrt58dpkeape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.39,273.7c-24.84,14.34-65.11,14.34-89.95,0-12.42-7.17-18.62-16.57-18.62-26s6.2-18.79,18.62-26c24.84-14.35,65.11-14.34,89.95,0,12.42,7.17,18.63,16.56,18.63,26S235.81,266.53,223.39,273.7Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "178.42px 247.698px"
    },
    id: "elkl92ud9q21",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0pgdrwwrzj8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.39,273.7c-24.84,14.34-65.11,14.34-89.95,0-12.42-7.17-18.62-16.57-18.62-26s6.2-18.79,18.62-26c24.84-14.35,65.11-14.34,89.95,0,12.42,7.17,18.63,16.56,18.63,26S235.81,266.53,223.39,273.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "178.42px 247.698px"
    },
    className: "animable",
    id: "elel3lx0v5nvp"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0l3qd2bn5bz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.08,255.74a30.85,30.85,0,0,0,9.26-26.54,48.94,48.94,0,0,0-10-7.43c-24.84-14.34-65.11-14.34-89.95,0-12.42,7.17-18.62,16.56-18.62,26s6.2,18.8,18.62,26c21.17,12.21,53.53,14,78,5.41-25,7.66-57.45.83-60.21-12.7C166.23,272.72,204.47,275.3,224.08,255.74Z",
    style: {
      fill: "#3293C4",
      opacity: 0.3,
      transformOrigin: "174.2px 247.762px"
    },
    className: "animable",
    id: "elvly9tuaz7d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.31,275.28a23,23,0,0,0,23,39.8c2.94-1.7,4.76-5.34,4.76-10.52,0-10.37-7.27-23-16.24-28.15C123.32,273.82,119.25,273.58,116.31,275.28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "124.812px 295.972px"
    },
    id: "elpbfwf6jbgdh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.61,312.4c-11.76,1.07-20.24-8.35-21.6-20.11a23,23,0,0,0,34.28,22.79c2.94-1.7,4.76-5.34,4.76-10.52a27,27,0,0,0-.88-6.55C143.16,304.58,139.2,311.25,126.61,312.4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "124.442px 305.213px"
    },
    id: "el0omp57awkace",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.45,295.37c-3.6-2.07-6.51-.39-6.51,3.76a14.36,14.36,0,0,0,6.51,11.27c3.59,2.08,6.5.39,6.5-3.76A14.39,14.39,0,0,0,114.45,295.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "114.445px 302.887px"
    },
    id: "elk9cxy8oewrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.28,297.78a14.4,14.4,0,0,0,6.51,11.27,5.49,5.49,0,0,0,3.27.86,5.52,5.52,0,0,0,.89-3.27,14.39,14.39,0,0,0-6.5-11.27,5.59,5.59,0,0,0-3.28-.86A5.59,5.59,0,0,0,110.28,297.78Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "115.615px 302.211px"
    },
    id: "el6edywqqjugj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli3do6ru8fqn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.57,300.14a14.59,14.59,0,0,0,6.22,8.91,5.49,5.49,0,0,0,3.27.86,5.52,5.52,0,0,0,.89-3.27,11.34,11.34,0,0,0-.53-3.28C118.4,307,111.61,303.67,110.57,300.14Z",
    style: {
      opacity: 0.1,
      transformOrigin: "115.763px 305.029px"
    },
    className: "animable",
    id: "elm1zmma1mx3p"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.9,307.72a4.5,4.5,0,0,0,.3-1.73,10.49,10.49,0,0,0-4.75-8.22c-1.79-1-3.35-.78-4.15.44a1.92,1.92,0,0,0-.18.31c-8.63,15.13-11,40.14,8.9,66l9.52-7.31C113.69,337.87,113.69,319.65,118.9,307.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "116.134px 330.83px"
    },
    id: "elogaw5wfx3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.54,382.69a2.52,2.52,0,0,1-2.11-1.15,14.77,14.77,0,0,1,.65-17.21,2.5,2.5,0,0,1,4,3,9.86,9.86,0,0,0-.44,11.5,2.5,2.5,0,0,1-2.1,3.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "118.777px 373.012px"
    },
    id: "el4lb9942q18b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8lizs6vzd8g"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 123.78,
    cy: 360.83,
    r: 11.54,
    style: {
      fill: "#3293C4",
      transformOrigin: "123.78px 360.83px",
      transform: "rotate(-50.1deg)"
    },
    className: "animable",
    id: "ele2tbue3xdn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhrfmygqo8r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.58,368.29c-1.46,1.52-7.58,3-11.63-2.45-4.65-6.28-.34-16.09,6-16.1a11.54,11.54,0,1,0,5.65,18.55Z",
    style: {
      opacity: 0.2,
      transformOrigin: "122.424px 360.838px"
    },
    className: "animable",
    id: "elcx0qnsvm8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1rwshdp9ihx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.67,353.13a2.27,2.27,0,0,0-.28-.26,7.11,7.11,0,0,0-1.8-1.11,4,4,0,0,0-2.32-.41,1.7,1.7,0,0,0-1.4,1.77c.15.79,1,1.22,1.71,1.56a30.87,30.87,0,0,1,5.31,3.21.75.75,0,0,0,.57.21c.27-.06.37-.39.38-.67C132.94,355.78,131.78,354.35,130.67,353.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "128.857px 354.71px"
    },
    className: "animable",
    id: "el0h52pav5rtof"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.68,375.18A2.5,2.5,0,0,1,138.2,373a9.85,9.85,0,0,0-7.56-8.68,2.5,2.5,0,0,1,1.22-4.85,14.76,14.76,0,0,1,11.31,13,2.49,2.49,0,0,1-2.21,2.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "135.969px 367.308px"
    },
    id: "el1lb4gqsjwdo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.72,228.16c0-7.58-5-15.16-15-20.94-20-11.57-52.51-11.57-72.55,0-10,5.78-15,13.36-15,20.94v9.39c0,7.58,5,15.16,15,20.94,20,11.57,52.52,11.57,72.55,0,10-5.78,15-13.36,15-20.94Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "178.445px 232.855px"
    },
    id: "elmk582e8ca4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.47,266.79c-12.34.25-28.38-5.37-24.3-19.86V200.07a64.9,64.9,0,0,0-20,7.15c-10,5.78-15,13.36-15,20.94v9.39c0,7.58,5,15.16,15,20.94C154.21,265.46,170.81,268.22,186.47,266.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.82px 233.613px"
    },
    id: "elxmozyjnlnmd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.69,249.11c-20,11.57-52.51,11.56-72.55,0-10-5.79-15-13.37-15-21s5-15.16,15-20.94c20-11.57,52.52-11.57,72.55,0,10,5.78,15,13.36,15,20.94S224.71,243.32,214.69,249.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "178.415px 228.138px"
    },
    id: "el4g5skp79oty",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.45,242l-2.22-2c2.14-2.37,4.6-6,4.15-10-.34-2.94-2.29-5.66-5.81-8.08a56.25,56.25,0,0,0-13-6.71c-.28-1.16-.85-3-1-3.5a57.61,57.61,0,0,1,15.71,7.74c4.25,2.93,6.64,6.37,7.08,10.2C252.94,234.73,250,239.16,247.45,242Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.002px 226.855px"
    },
    id: "ele27yh0veldh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.36,238.17c-2.9-2.27-4.83-1-8.7,3.72s-2.78,6.64-.38,8.53,5,.73,8.06-3.21C250.74,242.78,251.81,240.88,248.36,238.17Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "243.794px 244.191px"
    },
    id: "elt6wn2whot7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els4nq3zpm5p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.7,241.4a14.07,14.07,0,0,0-2.61,3.3,3.2,3.2,0,0,0-.3,2.67,3,3,0,0,0,.78,1,3.7,3.7,0,0,0,2.36,1.06.77.77,0,0,0,.45-.1.73.73,0,0,0,.26-.56c.12-.93-.13-1.87,0-2.8.27-2.36,2.75-4.09,2.77-6.46a.81.81,0,0,0-.07-.38c-.26-.48-1-.19-1.39,0a3.2,3.2,0,0,0-.47.43c-.26.27-.53.54-.79.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "242.019px 244.15px"
    },
    className: "animable",
    id: "elw50n6y1sh4q"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M235.86,225.82a57.45,57.45,0,1,0-114.89,0c0,8.48,5.61,17,16.83,23.45,22.43,13,58.8,13,81.24,0C230.26,242.79,235.86,234.31,235.86,225.82Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "178.415px 213.316px"
    },
    id: "elwdi5mkp62a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcg5byoset8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.86,225.82a57.45,57.45,0,1,0-114.89,0c0,8.48,5.61,17,16.83,23.45,22.43,13,58.8,13,81.24,0C230.26,242.79,235.86,234.31,235.86,225.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "178.415px 213.316px"
    },
    className: "animable",
    id: "el2s9sk7cthmf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldt1txbp0ifd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.32,242.25c-29.88,18.41-69.32,16.46-70.21-3.09-.61-13.34-7.5-24.47-16.47-29.63.91-21,14.85-37.65,29.92-40.73h0a57.44,57.44,0,0,0-50.58,57c0,8.48,5.61,17,16.83,23.45,22.43,13,58.8,13,81.24,0a46.31,46.31,0,0,0,6.88-4.81l2.31-2.12Z",
    style: {
      fill: "#3293C4",
      opacity: 0.3,
      transformOrigin: "174.65px 213.9px"
    },
    className: "animable",
    id: "eliww562wr77e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,211.77a57.26,57.26,0,0,0-15.24-26.72c0,6-3.93,12-11.84,16.53-9.32,5.38-22,7.59-34.17,6.63A10.52,10.52,0,0,0,161.61,217c-.88,5.44-1.42,10.71-1.73,15.4a10.39,10.39,0,0,0,9.3,11.08c17.16,1.66,35.4-1.33,48.63-9C228.68,228.21,234.12,220,234.12,211.77Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "196.987px 214.487px"
    },
    id: "eljl9afnd95s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.62,229.55a2.59,2.59,0,0,1-.48,0,2.5,2.5,0,0,1-2-2.93,11.35,11.35,0,0,1,20.55-4.18,2.5,2.5,0,0,1-4.15,2.8,6.35,6.35,0,0,0-11.49,2.33A2.5,2.5,0,0,1,183.62,229.55Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "191.607px 223.499px"
    },
    id: "elw8ysun54ox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4c4s6vv6774"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.62,229.55a2.59,2.59,0,0,1-.48,0,2.5,2.5,0,0,1-2-2.93,11.35,11.35,0,0,1,20.55-4.18,2.5,2.5,0,0,1-4.15,2.8,6.35,6.35,0,0,0-11.49,2.33A2.5,2.5,0,0,1,183.62,229.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "191.607px 223.499px"
    },
    className: "animable",
    id: "elccy4qtnko2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.61,199.76a11.32,11.32,0,0,0-6.83,9.3,2.5,2.5,0,0,0,2.24,2.73,1.93,1.93,0,0,0,.48,0,2.5,2.5,0,0,0,2.25-2.24,6.34,6.34,0,0,1,3.95-5.23Q230.76,202,229.61,199.76Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "227.234px 205.782px"
    },
    id: "elstnyff7pge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6g1lsauc99"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.61,199.76a11.32,11.32,0,0,0-6.83,9.3,2.5,2.5,0,0,0,2.24,2.73,1.93,1.93,0,0,0,.48,0,2.5,2.5,0,0,0,2.25-2.24,6.34,6.34,0,0,1,3.95-5.23Q230.76,202,229.61,199.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "227.234px 205.782px"
    },
    className: "animable",
    id: "elfybgf8680a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhiph8vo3fqo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "208.415px 220px"
    },
    className: "animable",
    id: "elz6fpyis88oh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.38,201.38a119.42,119.42,0,0,1,11.73,32.32,42.57,42.57,0,0,0,6.31-4.69c-2.32-8.78-6.32-20.6-12.87-31.39A31.76,31.76,0,0,1,207.38,201.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "216.4px 215.66px"
    },
    id: "elnlkrud77fx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,203.72a54.53,54.53,0,0,1-11.35,3.47,252.5,252.5,0,0,1,4,35.19,76,76,0,0,0,16.46-4.91A207.8,207.8,0,0,0,202.76,203.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "201.64px 223.05px"
    },
    id: "el5bw9hytfffh",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,199.53a4.95,4.95,0,1,1-7,0A5,5,0,0,1,106.47,199.53Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "102.97px 203.041px"
    },
    id: "eladfk7rsi4ob",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw330xbdk8i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.47,199.53a4.95,4.95,0,1,1-8,1.44c0,.12,0,.25.08.37.46,1.45,2.48,2.09,4.5,1.44s3.25-2.3,2.82-3.74A3.83,3.83,0,0,1,106.47,199.53Z",
    style: {
      opacity: 0.3,
      transformOrigin: "102.971px 203.51px"
    },
    className: "animable",
    id: "elm8nmyj870a9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M105.76,204.07a2.76,2.76,0,0,0-1.74,1.75.87.87,0,0,0,.14.86l21,21,2.47-2.47-21-21A.86.86,0,0,0,105.76,204.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.797px 215.845px"
    },
    id: "elx9k4cumwv5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elywx99p6mdd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8,199.83a.74.74,0,0,0-.15.79c.2.29.65.2,1,.1a19,19,0,0,1,3.78-.38,1.65,1.65,0,0,0,.73-.15.5.5,0,0,0,.11-.73,2,2,0,0,0-.68-.57,3.54,3.54,0,0,0-2.07-.45,3.91,3.91,0,0,0-1.8.55A3.31,3.31,0,0,0,99.8,199.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "102.488px 199.621px"
    },
    className: "animable",
    id: "el00xx1ztyp7dfh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.3,210.61a23,23,0,0,0,23,39.8c2.94-1.7,4.76-5.34,4.76-10.52,0-10.36-7.27-23-16.24-28.14C133.31,209.16,129.24,208.91,126.3,210.61Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.802px 231.304px"
    },
    id: "el5057rkwzgd6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,247.73c-11.76,1.07-20.24-8.35-21.6-20.11a23,23,0,0,0,34.28,22.79c2.94-1.7,4.76-5.34,4.76-10.52a26.87,26.87,0,0,0-.87-6.54C153.15,239.92,149.19,246.58,136.6,247.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "134.432px 240.543px"
    },
    id: "elda22allsn0q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,230.71c-3.6-2.08-6.51-.4-6.51,3.75a14.36,14.36,0,0,0,6.51,11.27c3.59,2.08,6.5.4,6.5-3.75A14.38,14.38,0,0,0,124.44,230.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "124.435px 238.22px"
    },
    id: "elwd4j0owlxzl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27,233.11a14.39,14.39,0,0,0,6.51,11.27,5.49,5.49,0,0,0,3.27.86,5.46,5.46,0,0,0,.89-3.26,14.38,14.38,0,0,0-6.5-11.27,5.52,5.52,0,0,0-3.28-.86A5.53,5.53,0,0,0,120.27,233.11Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "125.605px 237.545px"
    },
    id: "el4y442ql1pkd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0mgdz2zrsoz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.56,235.47a14.56,14.56,0,0,0,6.22,8.91,5.49,5.49,0,0,0,3.27.86,5.46,5.46,0,0,0,.89-3.26,11.35,11.35,0,0,0-.53-3.29C128.39,242.31,121.6,239,120.56,235.47Z",
    style: {
      opacity: 0.1,
      transformOrigin: "125.753px 240.359px"
    },
    className: "animable",
    id: "elx7n4skw2sm9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196.3,154.2a23.31,23.31,0,0,0-23.53,0l-12.39,7.16a59,59,0,0,0-29.44,51h0a1,1,0,0,0,.59.82,3.14,3.14,0,0,0,2.83,0,1,1,0,0,0,.58-.82h0a55,55,0,0,1,27.44-47.51l12.39-7.16A19.53,19.53,0,0,1,204,173.47s0,.92,0,.93c1.91.93,4,2.2,4,2.2v-2A23.31,23.31,0,0,0,196.3,154.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.47px 182.265px"
    },
    id: "el6hutn3jx7tv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,215.14a14.37,14.37,0,0,0-8.47-2.22c-.49.41-1,.83-1.41,1.27a8.4,8.4,0,0,1,2.38-.34,14.26,14.26,0,0,1,7,2.15c8.83,5.1,16,17.53,16,27.71,0,3.94-1.08,7-3,8.94.6-.16,1.21-.37,1.81-.59a14.47,14.47,0,0,0,2.23-8.35C148,233.21,140.59,220.39,131.49,215.14Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "134.826px 232.775px"
    },
    id: "el09m131507o4g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5zf1ab19b53"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "134.826px 232.775px"
    },
    className: "animable",
    id: "elod7ya77k15d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.49,215.14a14.37,14.37,0,0,0-8.47-2.22c-.49.41-1,.83-1.41,1.27a8.4,8.4,0,0,1,2.38-.34,14.26,14.26,0,0,1,7,2.15c8.83,5.1,16,17.53,16,27.71,0,3.94-1.08,7-3,8.94.6-.16,1.21-.37,1.81-.59a14.47,14.47,0,0,0,2.23-8.35C148,233.21,140.59,220.39,131.49,215.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "134.826px 232.775px"
    },
    id: "elnlyyxqjcg2n",
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63",
    className: "animable",
    style: {
      transformOrigin: "389.581px 341.742px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cushion--inject-63",
    className: "animable",
    style: {
      transformOrigin: "439.425px 349.117px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417.31,302.74c4.71-1.72,10.14,2.83,19.22,4.71,16.9,3.5,25.37,8.45,34.46,14.81s11.37,4.31,14.81,8.84-1.91,8.23-2.88,16.16c-1.64,13.36-5.45,23-10.3,29.67-8.56,11.72-5.31,17.52-10.26,18.72-5.28,1.29-6.05-3.32-15.14-4.41-21.49-2.59-31.25-7.3-43.71-18.36-4.86-4.31-9.24-2.72-11.39-7.55-1.07-2.41,2.25-4.71,3.53-13.47,2.13-14.55,7.75-29.14,14.67-37.74C413.34,310.37,412.51,304.49,417.31,302.74Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "439.425px 349.117px"
    },
    id: "elhomrkkuyd0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbosy0avo81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M482.65,340.93c-2.63,6.91-.59,12.61-6.33,25.55-5.51,12.42-10.67,16.84-11.93,22.1-1,4.38-3.35,6.89-5.17,2.55S457.64,373,463,359.86c6.21-15.13,11-21.54,14.62-24.45C483.32,330.84,484.72,335.49,482.65,340.93Z",
    style: {
      opacity: 0.2,
      transformOrigin: "470.876px 363.47px"
    },
    className: "animable",
    id: "eljb6fdfhkbo"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldwqum3p3x0f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.79,386c6.29,2.46,13.64,4.08,23.43,5.26a21.93,21.93,0,0,1,9.39,3.32c-3.66-3-5.11-7.73-11-8.21C441.36,386,431.63,387.85,423.79,386Zm-31.05-19.54c2.3,3.47,6.33,2.5,10.77,6.44a78.45,78.45,0,0,0,12.57,9.38c-5.37-4.26-6.45-9.82-10.58-12C400.53,367.54,396.65,369.43,392.74,366.44Z",
    style: {
      opacity: 0.2,
      transformOrigin: "424.675px 380.51px"
    },
    className: "animable",
    id: "elts8bi5jp929"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elx1nfimrk82n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427,312.66c12.06-.8,25.09,2.19,35.28,9a9.43,9.43,0,0,1,3.81,6.14,9.24,9.24,0,0,1-2.78,8.47c-2.31,2.23-6.27,3.24-9.19,3.6-6.16.77-10.07.11-17.8,2a18.41,18.41,0,0,0-7.6,4.13c-3.26,3.09-5.48,6.21-8.36,8.84-3.95,3.63-12.38,4.6-15.93,2.49-3.79-2.25-5.63-6.61-4.39-13C402.83,330.13,410.87,315,427,312.66Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.05,
      transformOrigin: "432.953px 335.483px"
    },
    className: "animable",
    id: "elzvnw6vk794q"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cushion--inject-63",
    className: "animable",
    style: {
      transformOrigin: "338.08px 329.398px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.51,292.21c-3.75-1.47-8.21,2.07-15.54,3.4-13.65,2.48-24,7.06-31.44,12s-9.23,3.24-12.08,6.81,1.37,6.65,2,13c1,10.77,3.91,18.62,7.68,24.05,6.64,9.59,3.91,14.18,7.87,15.25,4.21,1.14,4.93-2.55,12.25-3.24,17.32-1.65,28.71-6,38.94-14.65,4-3.37,7.49-2,9.31-5.84.91-1.92-1.72-3.83-2.57-10.89-1.42-11.75-5.65-23.58-11-30.63C361.54,298.43,362.33,293.72,358.51,292.21Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "338.08px 329.398px"
    },
    id: "eldh7wtt8y4o9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elu66xe9gbvd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.51,292.21c-3.75-1.47-8.21,2.07-15.54,3.4-13.65,2.48-24,7.06-31.44,12s-9.23,3.24-12.08,6.81,1.37,6.65,2,13c1,10.77,3.91,18.62,7.68,24.05,6.64,9.59,3.91,14.18,7.87,15.25,4.21,1.14,4.93-2.55,12.25-3.24,17.32-1.65,28.71-6,38.94-14.65,4-3.37,7.49-2,9.31-5.84.91-1.92-1.72-3.83-2.57-10.89-1.42-11.75-5.65-23.58-11-30.63C361.54,298.43,362.33,293.72,358.51,292.21Z",
    style: {
      opacity: 0.3,
      transformOrigin: "338.08px 329.398px"
    },
    className: "animable",
    id: "el6vr869ztf4f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elaxd8r11d1x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.79,322.37c2,5.61.22,10.15,4.57,20.66,4.18,10.09,8.24,13.74,9.14,18,.76,3.54,2.56,5.6,4.11,2.15s1.63-14.54-2.44-25.21c-4.69-12.28-8.42-17.53-11.26-19.94C301.45,314.25,300.23,318,301.79,322.37Z",
    style: {
      opacity: 0.2,
      transformOrigin: "310.869px 340.712px"
    },
    className: "animable",
    id: "elwatjrenlcbi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2iffagas59a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.63,359.61c-4.73.27-6,4-9,6.38a17.65,17.65,0,0,1,7.61-2.48c7.89-.76,13.83-1.91,18.93-3.76C341.85,361.09,334.06,359.42,330.63,359.61Zm36-12.93c-3.37,1.7-4.34,6.15-8.75,9.46a62.59,62.59,0,0,0,10.29-7.28c3.65-3.08,6.87-2.22,8.79-5C373.77,346.22,370.7,344.62,366.65,346.68Z",
    style: {
      opacity: 0.2,
      transformOrigin: "349.295px 354.925px"
    },
    className: "animable",
    id: "eljm68wo605ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elbrebi6btetn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.51,300c-9.68-.88-22.17,1.08-30.49,6.37-1.58,1.09-4.33,3.79-4.68,5.8A7.44,7.44,0,0,0,317.4,319c1.82,1.83,5,2.73,7.32,3.08,4.93.73,9.64-.51,16.13.72a19.39,19.39,0,0,1,7.6,3.91c2.56,2.54,4.29,5.09,6.55,7.27,3.1,3,9.86,3.94,12.75,2.32,3.09-1.74,4.66-5.21,3.79-10.36C369.6,314.52,363.44,302.16,350.51,300Z",
    style: {
      fill: "#3293C4",
      opacity: 0.3,
      transformOrigin: "343.48px 318.441px"
    },
    className: "animable",
    id: "el2vcm5z936x5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-63",
    className: "animable",
    style: {
      transformOrigin: "373.91px 341.742px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-63",
    className: "animable",
    style: {
      transformOrigin: "368.67px 409.587px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.93,413.45l-9.7-17.5-20.31,12.16,21.95,25.66s12.16-.69,14.23-6.46S362.93,415.54,359.93,413.45Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "348.246px 414.86px"
    },
    id: "elqlrf6qb3kqh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.12,422a9.61,9.61,0,0,1,2.41,2.9c.69,1.13.21,6.44.8,8.94s1.11,3.18,2.15,6.33c1.14,3.49,3.42,6.73.28,15.41s-7.72,12.68-11.51,14.66a9.69,9.69,0,0,1-4.5.87s-4.75-2.05-3.88-4.88S371.12,422,371.12,422Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.558px 446.561px"
    },
    id: "elxx01sp22q2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.44,430.67c.09.92,1.3,2.37,1.78,3.14,1.62,2.57,2.26,6,2.72,8.95,2.21,14.07-3.66,20.9,3.6,26.48,2.11,1.47,6.64,1.3,13.9-7.17,3.71-4.32,6.14-13.46,5-17.7s-2.91-7.05-3.64-10.31,0-9.23-1.64-12.07a13,13,0,0,0-4.18-3.95c-1.29-.87-2.74-3-4.07-3.78s-2-1.75-2.94-.81l1.47,2c2.29,3.5.18,4.85,0,6.65a28.52,28.52,0,0,0,.65,5.78c-1.64-2.27-2.26-4.23-4.18-4s-2.14.15-5,2.58S349.36,429.86,349.44,430.67Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "363.079px 441.503px"
    },
    id: "el3smuzoo3aih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljasdo36bob9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.44,430.67c.09.92,1.3,2.37,1.78,3.14,1.62,2.57,2.26,6,2.72,8.95,2.21,14.07-3.66,20.9,3.6,26.48,2.11,1.47,6.64,1.3,13.9-7.17,3.71-4.32,6.14-13.46,5-17.7s-2.91-7.05-3.64-10.31,0-9.23-1.64-12.07a13,13,0,0,0-4.18-3.95c-1.29-.87-2.74-3-4.07-3.78s-2-1.75-2.94-.81l1.47,2c2.29,3.5.18,4.85,0,6.65a28.52,28.52,0,0,0,.65,5.78c-1.64-2.27-2.26-4.23-4.18-4s-2.14.15-5,2.58S349.36,429.86,349.44,430.67Z",
    style: {
      opacity: 0.4,
      transformOrigin: "363.079px 441.503px"
    },
    className: "animable",
    id: "elduxaw2tqku4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elqmaxm6hiqi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.44,462.07c3.71-4.32,6.14-13.46,5-17.7a37.37,37.37,0,0,0-1.42-4.13c0,.29.12.58.15.82.06.55.1,1.09.13,1.64a12.55,12.55,0,0,1-1,6.3c-.87,1.7-2.89,6-5.24,6-1.33,0-2.39-1.36-2.84-2.87-.18-.64-.46-2.34-.46-2.34a20.52,20.52,0,0,0-6.21,2.2c-3.51,2.09-3.41,2.6-3.41,2.6a8.85,8.85,0,0,1,0,3,7.42,7.42,0,0,1-1.4,2.92,4.87,4.87,0,0,1-.9.65c0,3.22.71,5.79,3.76,8.13C359.65,470.71,364.18,470.54,371.44,462.07Z",
    style: {
      opacity: 0.3,
      transformOrigin: "365.282px 455.101px"
    },
    className: "animable",
    id: "el664jred90wa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M353.94,442.76a47.22,47.22,0,0,1,.36,11.18c1.11,3.63,2.24,3.58,2.48,1.74s-1.87-9.64-3.41-16.07C353.6,440.68,353.79,441.74,353.94,442.76Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "355.084px 448.261px"
    },
    id: "elamibtogb14i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.47,420.8c.28-1.73,1.23-4.42.28-6.05-.33-.17-.63-.34-.88-.49-1.43-.91-2-1.75-2.94-.81l1.47,2c2.29,3.5.18,4.85,0,6.65a28.52,28.52,0,0,0,.65,5.78c1.14,6.12,2.34,8.2,2.74,13.95s-.92,9.54-.12,9.9,2.45-.21,3-4.78-1.16-12.36-2.41-16.08S363.06,423.23,363.47,420.8Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "363.853px 432.428px"
    },
    id: "elero5a6t0298",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.12,450.16a.57.57,0,0,1-.3.15c-4.05.64-6.24,1.55-9.39,4.93a.59.59,0,0,1-.81,0,.58.58,0,0,1,0-.81c3.33-3.57,5.74-4.6,10.05-5.28a.57.57,0,0,1,.65.48A.57.57,0,0,1,366.12,450.16Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "360.891px 452.272px"
    },
    id: "elao02dzq7ms7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.62,445.36a.54.54,0,0,1-.3.15,15.38,15.38,0,0,0-9.9,5.4.58.58,0,0,1-.83,0,.59.59,0,0,1,0-.83c3.53-3.74,6.09-4.93,10.54-5.74a.59.59,0,0,1,.51,1Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "360.116px 447.709px"
    },
    id: "ellkmbjy8nki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,440.12a.65.65,0,0,1-.32.16c-4.63.85-7.38,2.14-11.07,6.06a.64.64,0,0,1-.91,0,.65.65,0,0,1,0-.91c3.88-4.12,6.87-5.55,11.78-6.45a.64.64,0,0,1,.55,1.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "359.882px 442.748px"
    },
    id: "eljnq1ywvahzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.41,435.6a.73.73,0,0,1-.32.15c-4.54.83-7.2,2.08-10.82,5.93a.65.65,0,0,1-.9,0,.64.64,0,0,1,0-.9c3.8-4,6.71-5.42,11.51-6.3a.62.62,0,0,1,.74.51A.65.65,0,0,1,365.41,435.6Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "359.408px 438.164px"
    },
    id: "eljapueryz82g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364,431.15a.65.65,0,0,1-.32.16c-4.54.83-7.2,2.07-10.82,5.93a.64.64,0,0,1-.9,0,.62.62,0,0,1,0-.89c3.8-4.05,6.7-5.43,11.51-6.31a.64.64,0,0,1,.55,1.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "357.993px 433.728px"
    },
    id: "eluzsg5mdyxzt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.14,351.56s-32.22-6.38-57.88-1.93c-18.62,3.23-16.92,18.35-13.58,27.66,6.59,18.41,36.89,47.4,36.89,47.4s14-6.07,17-15.32l-7.69-16.24L375,399.72l2.55-3.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "340.563px 386.371px"
    },
    id: "elvknuu143vid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.06,419.18c3.32,3.41,5.51,5.51,5.51,5.51s14-6.07,17-15.32l-3.13-6.62Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "348.315px 413.72px"
    },
    id: "elwdfx4pq60xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.68,379.23a162.42,162.42,0,0,1,10,15.56l-5.83-1.66c-7-15.3-8.46-19.78-19.08-26.72C332.8,366.41,340.35,369,347.68,379.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "345.225px 380.6px"
    },
    id: "elaq2aku6qci8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.89 416.12 338.99 425.84 332.26 430.06 339.24 444.92 361.58 434.23 350.89 416.12",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "346.92px 430.52px"
    },
    id: "elbdtynqcojud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,437.63c-5.09,2-8.23,4-10.59,7.1s-3.07,6.19-.83,9.91,6.34,8.1,11.21,7.82,7.88-1.5,12.4-4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.706px 450.051px"
    },
    id: "elnk9saewyvtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.68,441.94c.07,1.52-6.36,4.57-13,7.75-7.16,3.42-8.92,5.65-14.77,8.52-6.68,3.29-9.22,3.48-14.4,2s-11.58-8.86-7.13-15.69c3.63-5.56,8.34-7.09,15.48-9a135.43,135.43,0,0,0,16.7-5.39c5.16-2,9.4-5.6,10.47-4.36a39.88,39.88,0,0,0-5.11,4.6c-.27.46-.77,1.4.55.85a3,3,0,0,1,2.13-.2c.6.3,2.72,3.51,3.4,5.12.4.94,1.75,4.07,1,5.41-.28.52-2.23,1.93-1.58,2.31a3.76,3.76,0,0,0,2-.26c.47-.19,1-.32,1.51-.49S344.5,442.49,345.68,441.94Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "320.282px 443.306px"
    },
    id: "elhi5lfadkbfo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli0yuab5c7j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.68,441.94c.07,1.52-6.36,4.57-13,7.75-7.16,3.42-8.92,5.65-14.77,8.52-6.68,3.29-9.22,3.48-14.4,2s-11.58-8.86-7.13-15.69c3.63-5.56,8.34-7.09,15.48-9a135.43,135.43,0,0,0,16.7-5.39c5.16-2,9.4-5.6,10.47-4.36a39.88,39.88,0,0,0-5.11,4.6c-.27.46-.77,1.4.55.85a3,3,0,0,1,2.13-.2c.6.3,2.72,3.51,3.4,5.12.4.94,1.75,4.07,1,5.41-.28.52-2.23,1.93-1.58,2.31a3.76,3.76,0,0,0,2-.26c.47-.19,1-.32,1.51-.49S344.5,442.49,345.68,441.94Z",
    style: {
      opacity: 0.4,
      transformOrigin: "320.282px 443.306px"
    },
    className: "animable",
    id: "el1cp9n109ghd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el4alurquakis"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.16,457.11c-1,.48-7,3.3-8.92,1.61-2.07-1.83,2.8-4.75,2.8-4.75s.74-4.57-4.78-11.3c-1,.74-4.94.7-4.89-1.65s6.74-5.22,6.83-5.26c-6.83,1.83-11.33,3.4-14.86,8.8-4.45,6.83,1.94,14.25,7.13,15.69s7.72,1.25,14.4-2C318.54,457.88,319.58,457.45,320.16,457.11Z",
    style: {
      opacity: 0.3,
      transformOrigin: "307.501px 448.433px"
    },
    className: "animable",
    id: "elmz1dltnul7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.39,453.51c-2.53.85-.8,3.15,2.91,2.4,5.55-1.12,10.16-4.27,16.34-6.22,6.68-3.18,13.49-6.15,13.05-7.84-1.2.45-3.75,1.51-3.75,1.51-.5.22-1.79.7-1.79.7-5.07,2.18-10.67,5.7-16.15,7.18C319.18,452.55,315.92,452.67,313.39,453.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "328.953px 448.954px"
    },
    id: "el9hu3uep6zp8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.63,443.53c2.31-1.34,2.72-2.48,7.26-4.57s12.21-6.54,16.95-9.3a59.18,59.18,0,0,0,5.15-3.82c-.79-.89-3.68-.06-6.57,1.76s-4.66,3-7.53,4.48c-5.57,3.35-11.92,5.61-15.1,7.66S307.31,444.87,309.63,443.53Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "323.316px 434.669px"
    },
    id: "eluafdteh9cle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.29,442.92a.63.63,0,0,0,.13.2,20.23,20.23,0,0,1,4.33,11.21.67.67,0,0,0,.63.62.55.55,0,0,0,.52-.64c-.71-7.67-4.51-11.84-4.72-12.06a.53.53,0,0,0-.81,0A.66.66,0,0,0,309.29,442.92Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "312.07px 448.506px"
    },
    id: "elculmyj4lz4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.78,439.64a.52.52,0,0,0,.11.19,27.59,27.59,0,0,1,5.37,13.22.66.66,0,0,0,.65.61.56.56,0,0,0,.49-.67,28.47,28.47,0,0,0-5.71-14,.55.55,0,0,0-.82-.06A.65.65,0,0,0,313.78,439.64Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "317.062px 446.217px"
    },
    id: "eld88f36y2gbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.67,452.58a.64.64,0,0,0,.53.41.56.56,0,0,0,.56-.61c-.27-8.11-5.49-15.72-5.74-16a.53.53,0,0,0-.81,0,.7.7,0,0,0,.05.9c.05.06,5.1,7.5,5.34,15.05A.77.77,0,0,0,323.67,452.58Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "321.416px 444.591px"
    },
    id: "elj9yxazzswdn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.82,449.93a.63.63,0,0,0,.52.4.54.54,0,0,0,.57-.59,23.9,23.9,0,0,0-6.05-15.17.54.54,0,0,0-.81,0,.7.7,0,0,0,.1.9,23,23,0,0,1,5.61,14.15A.64.64,0,0,0,327.82,449.93Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "325.421px 442.359px"
    },
    id: "elf1ge0bjyuy5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2,447.66a.65.65,0,0,0,.52.4.54.54,0,0,0,.57-.58c0-8.44-6-15-6.23-15.23a.53.53,0,0,0-.81,0,.68.68,0,0,0,.08.9c.06.06,5.78,6.37,5.81,14.21A.72.72,0,0,0,333.2,447.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "330.704px 440.061px"
    },
    id: "elzmqynk4ant",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.12,351.18l66.75,12.23s6.63,25,.94,39.82-20.59,19.5-27.72,20c-10.2.79-22-2.36-22-2.36a56.69,56.69,0,0,1-11.84,7c-6,2.37-32.07,13.3-32.07,13.3s-10.59-3.42-9.86-16.35l30.87-32.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "392.2px 396.175px"
    },
    id: "eljtyv8yj9vfr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.56,412.22s-3.94,5.72-16.72,11.14c-6.78,2.88-28.49,13.19-36.56,15.66a14.2,14.2,0,0,0,3.85,2.17s26.1-10.93,32.07-13.3a56.69,56.69,0,0,0,11.84-7C398.65,416,398.56,412.22,398.56,412.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "371.92px 426.705px"
    },
    id: "elnv2n3odngnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.7,418.47c6.38,1,23.58-2.14,29.16-14.26,5.47-11.86,3.63-26,2.41-38.2l2.06.49,2.38.55c1.58,7.48,4.47,24.83.1,36.18-5.69,14.79-20.59,19.5-27.72,20-10.2.79-22-2.36-22-2.36l3.39-5.25A43.67,43.67,0,0,0,406.7,418.47Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "419.104px 394.684px"
    },
    id: "el5ur2h02gafh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.87,397.11s2.51-2.7,5-5.67,6.6-8.57,17.08-8.17,30.62,2.22,30.62,2.22-21-3.58-28.26-4.79-12.09-.36-16.23,3.3-11.51,12.18-11.51,12.18Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "390.57px 388.647px"
    },
    id: "elibiq1h8ahyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.21,382.4a20.87,20.87,0,0,1-4.9-14.54s-2.51,9.56,1.51,16.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "378.373px 376.115px"
    },
    id: "el3abl3nyxzk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-63",
    className: "animable",
    style: {
      transformOrigin: "394.067px 301.304px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.57,279.59c-8,1.47-14.59,3.52-19.41,11.88-4.56,7.93-23.63,41.21-23.63,41.21l22.15,11.62,16.2-27.82Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "365.05px 311.945px"
    },
    id: "elx9l78t5uaj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrszi0o3wded"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.57,279.59c-8,1.47-14.59,3.52-19.41,11.88-4.56,7.93-23.63,41.21-23.63,41.21l22.15,11.62,16.2-27.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.55,
      transformOrigin: "365.05px 311.945px"
    },
    className: "animable",
    id: "eld5btgycrvt5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-63",
    className: "animable",
    style: {
      transformOrigin: "408.065px 301.304px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.32,308.94c2.75-22.77,11-28.61,15.16-29.89L407,277.3c4.9,1,25.41,9.28,31.09,11.25,3.65,1.27,5.23,9,6,21.2.64,9.89.74,18.17.41,31.83-.27,11.45-.55,24.5-4.05,40.42-26.38,5.46-55.55-6.59-68.87-32.37.74-3.16,1.07-7.13,1.64-15S374.58,315.11,375.32,308.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.132px 330.296px"
    },
    id: "elcs1axsddosq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.13,289.08l-17.65-8s-2.23,5.18-7,15.13-5,14.46-5.4,31.82,0,54.87-2,61.91c7.65,1.06,33-.76,37.62-3.58,0,0,.42-28.41,1.07-46.15S448.82,294.1,440.13,289.08Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "427.675px 335.663px"
    },
    id: "el8a8e3qegqju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldse0q77xee5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.13,289.08l-17.65-8s-2.23,5.18-7,15.13-5,14.46-5.4,31.82,0,54.87-2,61.91c7.65,1.06,33-.76,37.62-3.58,0,0,.42-28.41,1.07-46.15S448.82,294.1,440.13,289.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "427.675px 335.663px"
    },
    className: "animable",
    id: "elikuws9jvu1k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.52,279.59c-7,2.74-12.17,10.54-13.83,21.33s-3.31,32.79-4.47,40.93S375.56,362,375.56,362c-3.18-2-6.56-9-6.7-14,1.72-5,2-7.38,2.73-14.17s2.51-22.46,3.53-30.74,4-18.56,11.45-23.55a80.12,80.12,0,0,1,12.87-1.87Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "384.19px 319.835px"
    },
    id: "eld3jzoumczin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm7a3ghp4kx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.52,279.59c-7,2.74-12.17,10.54-13.83,21.33s-3.31,32.79-4.47,40.93S375.56,362,375.56,362c-3.18-2-6.56-9-6.7-14,1.72-5,2-7.38,2.73-14.17s2.51-22.46,3.53-30.74,4-18.56,11.45-23.55a80.12,80.12,0,0,1,12.87-1.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.35,
      transformOrigin: "384.19px 319.835px"
    },
    className: "animable",
    id: "el7qz061vsuaa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.93,307.15c1-7.94,5.48-22.15,14.08-25a6.9,6.9,0,0,0,.51-2.52l-.08-4.12a35.29,35.29,0,0,0-7.33,3.58c-3.71,2.4-10.12,10.06-11.77,16.25C384.06,292.13,385.54,297.27,384.93,307.15Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "389.93px 291.33px"
    },
    id: "eld30cm0m0krp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el84yjf6o6ctv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.93,307.15c1-7.94,5.48-22.15,14.08-25a6.9,6.9,0,0,0,.51-2.52l-.08-4.12a35.29,35.29,0,0,0-7.33,3.58c-3.71,2.4-10.12,10.06-11.77,16.25C384.06,292.13,385.54,297.27,384.93,307.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.55,
      transformOrigin: "389.93px 291.33px"
    },
    className: "animable",
    id: "el1cpbjbraxz8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-63",
    className: "animable",
    style: {
      transformOrigin: "408.874px 254.042px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.56,271.63c1.46-5.44,7.51-10.69,10.45-15.28,2.83-4.42,4.59-7.9,4.74-12.29.08-2.61-1.22-6.27-3.07-7.19,3.13-9.41-3.66-14.56-7.41-15.84a41.41,41.41,0,0,1-5.17-2c-2-1.07-2.31-2.79-3.86-4.38-2.66-2.73-7.53-3.25-9.74.3-1.69-2.67-4.31-2.86-7.4-2.38a5.18,5.18,0,0,0-4.5,5.45c-3.82-2.64-7.79-.14-8.39,2.2-.44,1.73-.21,3.24-1.5,4.7-1.46,1.64-3.89,1.38-4.5-.12-.65,2.45.14,4.44,2.85,4.56a5.64,5.64,0,0,0-1.15,4.68,5.18,5.18,0,0,0,4.32,4,9.08,9.08,0,0,0,.84,3.91,8.91,8.91,0,0,0,2.91,3.16c3.89,2.33,8.35,3.39,12.66,4.72l5.12,1.57c.3.1,1.87.34,2,.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.874px 241.997px"
    },
    id: "el66f8l1akt6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.94,265.11c-4.11,2-6.5-.81-6.5-.81l-.63,11.19,0,9.11s-11,11.8-26,11.09c-.76-3.36.33-9.27,2.75-12.16l.37-8.63a54,54,0,0,1-6.56-.92,11.51,11.51,0,0,1-8.41-9.6,50,50,0,0,1,1.2-18.86,16.24,16.24,0,0,0,.66-4.54c0-4.07.92-6.35,2.28-9.64,5.14-3.39,16.74-3.5,26.44,3.73-1.77,6,.15,11.09,4.38,13.85-.36,1.63-1,5.79,1.76,6,2,.13,2.33-2.31,4.54-4.29s7-2.11,8.48,1.26C435.76,256.56,433.44,263,428.94,265.11Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "409.009px 262.412px"
    },
    id: "eln703afg5nw9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.87,274.9c6.95-.16,12.25-.42,16.3-5.06a43.09,43.09,0,0,0,4.92-7.77s-1.28,6-3.92,9.95c-2,3-6.53,5.26-17.4,5.17Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "409.43px 269.631px"
    },
    id: "elo9ubqxe7r1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,247.9a1.95,1.95,0,1,0,2.19-1.76A2,2,0,0,0,403.44,247.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.382px 248.077px"
    },
    id: "elvi75ven69g7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.6,242.05l3.71,3a2.49,2.49,0,0,0-.4-3.43A2.32,2.32,0,0,0,405.6,242.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "407.709px 243.082px"
    },
    id: "eln6vly2rdjx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,240.75l4.74-.61a2.29,2.29,0,0,0-2.59-2.1A2.51,2.51,0,0,0,387.61,240.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "389.975px 239.385px"
    },
    id: "eldgmdemkvyua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,245.44a1.95,1.95,0,1,0,2.18-1.76A2,2,0,0,0,387.66,245.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "389.602px 245.618px"
    },
    id: "elfixd45zle7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,253.06l6.28,3.92,3.92-12.84C397.2,242.9,393.14,248.48,389.36,253.06Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "394.46px 250.472px"
    },
    id: "eler2mr5nesb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.16,261.18l-8.29.58a4.08,4.08,0,0,0,4.33,4A4.35,4.35,0,0,0,403.16,261.18Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "399.019px 263.474px"
    },
    id: "el7fn0usyfqv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,262.35a4.1,4.1,0,0,1,1,.16,4.31,4.31,0,0,1-3.8,3.23,3.86,3.86,0,0,1-1.32-.15A3.81,3.81,0,0,1,402,262.35Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "400.44px 264.04px"
    },
    id: "elki7w1bo0t4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.76,312.45c1.92-15.58,8.45-16.39,10-11.27,5.67-8.49,5.92-15.78,5.83-18.69-1.55-2.68-2.76-4.93-3.28-5.94-.68-1.33-1.46-1.06-1.46-1.06l0,4s-.91,4.54-5.57,10.27C412.78,293.92,411.58,299.3,410.76,312.45Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "418.681px 293.959px"
    },
    id: "elgi0d1l82ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elridswh69cvg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.76,312.45c1.92-15.58,8.45-16.39,10-11.27,5.67-8.49,5.92-15.78,5.83-18.69-1.55-2.68-2.76-4.93-3.28-5.94-.68-1.33-1.46-1.06-1.46-1.06l0,4s-.91,4.54-5.57,10.27C412.78,293.92,411.58,299.3,410.76,312.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.55,
      transformOrigin: "418.681px 293.959px"
    },
    className: "animable",
    id: "el3chhjsfm1ke"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-63",
    className: "animable",
    style: {
      transformOrigin: "353.112px 338.791px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333,316.78h0l1.55-1.46v0a1.84,1.84,0,0,1,1.65-.25l19.16,4.46a6.43,6.43,0,0,1,4.08,3.51l14,35.83a1.63,1.63,0,0,1-.16,1.86h0l-1.61,1.51v0a1.81,1.81,0,0,1-1.67.27l-19.16-4.46a6.43,6.43,0,0,1-4.08-3.51l-14-35.82A1.6,1.6,0,0,1,333,316.78Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "353.098px 338.791px"
    },
    id: "els8zto37om2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.76,322a6.26,6.26,0,0,1,2.14,2.59l14,35.81a1.74,1.74,0,0,1-.1,1.83l1.51-1.41h0a1.65,1.65,0,0,0,.16-1.87l-14-35.82a6.14,6.14,0,0,0-2-2.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.724px 341.455px"
    },
    id: "elf681pexnh1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.94,360.36l-14-35.83a6.45,6.45,0,0,0-4.08-3.51l-19.16-4.46c-1.64-.37-2.47.59-1.86,2.16l14,35.82a6.43,6.43,0,0,0,4.08,3.51l19.16,4.46C371.72,362.89,372.55,361.92,371.94,360.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.39px 339.537px"
    },
    id: "el7j4kmqnruup",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.18,332.15l-2.63-6.7a1.22,1.22,0,0,0-.76-.66l-3.31-.76c-.31-.07-.46.11-.35.4l2.63,6.71a1.19,1.19,0,0,0,.76.66l3.31.76C358.14,332.63,358.29,332.45,358.18,332.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "354.655px 328.295px"
    },
    id: "el544fmt2t58u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,327.08a3.06,3.06,0,0,0-1.95-1.62c-.79-.18-1.21.25-.92,1a3,3,0,0,0,1.94,1.62C355.32,328.22,355.74,327.79,355.46,327.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.022px 326.763px"
    },
    id: "elc12vp5l84jo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.74,330.47a3.05,3.05,0,0,0-1.94-1.63c-.8-.18-1.21.25-.93,1a3,3,0,0,0,1.94,1.62C356.6,331.61,357,331.18,356.74,330.47Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.301px 330.144px"
    },
    id: "elos8qrnner3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.35,339.61c-1.86-2.08-1.74-2.4-1-3.65a7.17,7.17,0,0,1,5.46-3.59c2-.16,4-.42,5.08,0s.44,2.66-2.08,3.53c-4,1.36-3.83,2.46-3.83,2.46a51.52,51.52,0,0,1,5.16-1.5c1.5-.25,4.33.17,6.08.25s2.33,2.27-.5,3.35l3.2.16c2.25.11,3.12,1.2,1.54,2.75a3.21,3.21,0,0,1-1.91,1s2.35-.26,2.48.52c.38,2.22-1,3-5.6,4.86-4.38,1.81-5,4.35-4,5.93,0,0-1.94-.86-3.68-1.8-1.28-.69-2.39-1.51-2.06-3.42,0,0-2.58.33-2.91-1.25a8.31,8.31,0,0,1,.25-3.49,2.86,2.86,0,0,1-1.72-2.5,4.61,4.61,0,0,1,.64-2.91Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "346.555px 343.911px"
    },
    id: "eldxktvkg7n6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.72,340.46a14.69,14.69,0,0,0-2.89,0,9.45,9.45,0,0,0-2.68,1.18,33,33,0,0,0-4.69,3.22,33.91,33.91,0,0,0,5.1-2.49A14.86,14.86,0,0,1,349,341.1C349.82,340.86,350.81,340.74,351.72,340.46Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "346.59px 342.624px"
    },
    id: "elrzkw835yfkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.55,344.34a6.34,6.34,0,0,0-3.11.25,16.76,16.76,0,0,0-2.84,1.25,29.16,29.16,0,0,0-5.07,3.47,60.6,60.6,0,0,0,5.47-2.73A16.25,16.25,0,0,1,354.55,344.34Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "349.04px 346.78px"
    },
    id: "elpcb5yn39vui",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385,364.21c-6.23-1.39-9.17-1.33-16.28-4.75a39.53,39.53,0,0,1-7-3.94,15.81,15.81,0,0,1-4.58-5.39,4.94,4.94,0,0,0-.63-1.15,11.14,11.14,0,0,0-.93-.89,8.55,8.55,0,0,1-1.72-1.73,13.84,13.84,0,0,1-1.07-2.39,11,11,0,0,0-.47-1.12,7.29,7.29,0,0,0-.73-1,10,10,0,0,1-1.85-2.67,1.71,1.71,0,0,1,.17-1.62s-1-.93-1.37-1.27a10,10,0,0,1-1.27-1.55A1.05,1.05,0,0,1,347,334a.76.76,0,0,1,.25-.36c1.67-1.59,3.94-.72,5.85.19,4.95,2.38,10.5,5.94,12.83,7.14s4.67,1.84,4.47.45-3.12-5-3.51-9.26c-.19-2.12,1.64-4.52,3.36-2.09,3.31,4.69,3.39,3.73,7.52,8,2.73,2.84,4.39,6.72,8.77,7.84s32,3.5,32,3.5l8.78-33.63s4.16-20.77,12.75-26.72c8.87,4,13.67,10.57,14.22,15.07,1,7.89-.89,14.85-5.63,33.16-4,15.53-7.91,25.22-10.85,30.73-3.65,6.82-6,6-20.77,3.73C406.23,370.07,391.26,365.6,385,364.21Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "400.775px 331.222px"
    },
    id: "elxk8p1l5gigb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,349.43c5.8-.78,12.54,2,12.54,2a22.91,22.91,0,0,0-12-3.76Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "424.87px 349.55px"
    },
    id: "eli7oele437q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,337.83c1,1,2.1,1.88,3.18,2.75s2.2,1.73,3.29,2.59c.55.43,1.08.89,1.66,1.3s1.15.79,1.74,1.15c1.19.73,2.39,1.41,3.62,2l-1.72-1.18c-.57-.38-1.15-.77-1.71-1.17s-1.14-.79-1.68-1.22-1.08-.87-1.63-1.3c-1.1-.87-2.22-1.7-3.36-2.5Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "356.745px 342.725px"
    },
    id: "el1yw4p96hypji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,342.69a17.42,17.42,0,0,0,2.15,2.53c.78.76,1.59,1.48,2.42,2.17s1.67,1.35,2.54,2a25.81,25.81,0,0,0,2.7,1.74c-.84-.68-1.65-1.38-2.48-2.07L357.08,347l-2.47-2.06C353.8,344.22,353,343.46,352.22,342.69Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "357.125px 346.91px"
    },
    id: "elcs4ljquw52k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,348.26c2.74,3.25,1.85,18.28,0,21.94a110.69,110.69,0,0,0,26.68,4.41c3.32.06,5-2.11,8-9.1s9.27-24.81,12-37.8,4.24-22.28,1.37-28.15-8-8.22-13.91-10.48c-3.82,2.21-9.79,8.64-13.57,24.72l-8.42,35Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "430.799px 331.846px"
    },
    id: "ela8nzpn25957",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaga83dy0i6q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M406,348.26c2.74,3.25,1.85,18.28,0,21.94a110.69,110.69,0,0,0,26.68,4.41c3.32.06,5-2.11,8-9.1s9.27-24.81,12-37.8,4.24-22.28,1.37-28.15-8-8.22-13.91-10.48c-3.82,2.21-9.79,8.64-13.57,24.72l-8.42,35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.55,
      transformOrigin: "430.799px 331.846px"
    },
    className: "animable",
    id: "el5ded52lsz2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgxc6zevk87p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.14,348.81a35.33,35.33,0,0,1,12,4.63s-2.61-5.54-11.47-7Z",
    style: {
      fill: "#3293C4",
      opacity: 0.35,
      transformOrigin: "424.14px 349.94px"
    },
    className: "animable",
    id: "elox7cdaf7ice"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-63",
    className: "animable",
    style: {
      transformOrigin: "403.705px 156.26px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63",
    className: "animable",
    style: {
      transformOrigin: "403.705px 156.26px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "397.375px 152.241px"
    },
    className: "animable",
    id: "elqxihspgdfh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.05,146.23c0,3.39-2.38,5.55-5.33,7.25L366,189.73c-2.93,1.7-5.33.33-5.33-3.08V160h0a10.62,10.62,0,0,1,5.3-9.2l62.78-36.3a3.55,3.55,0,0,1,5.33,3.08h0Z",
    id: "el6eyatc4m2zf",
    className: "animable",
    style: {
      transformOrigin: "397.375px 152.241px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63",
    className: "animable",
    style: {
      transformOrigin: "408.645px 158.619px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.72,125.67a7.25,7.25,0,0,0-3.25-5.45l-1.21-.7a7.27,7.27,0,0,0-6.55,0l-61.89,35.77a7.23,7.23,0,0,0-3.27,5.67v30.39a7.21,7.21,0,0,0,3.27,5.66l1.21.7a7.2,7.2,0,0,0,6.55,0l-.28.13,27.15-15.6a7.08,7.08,0,0,1,1.45-.63l5,4.44.38.29,2.74,1.55,5,2.91h0a4,4,0,0,0,3.77-.22c1.41-.82,2.56-3.17,2.56-5.26V173.91a7.22,7.22,0,0,1,3.27-5.67L443.47,162a7.23,7.23,0,0,0,3.27-5.67V125.91A1.94,1.94,0,0,0,446.72,125.67Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "408.645px 158.619px"
    },
    id: "elqq7d2dfb4ir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9v7f6jnq66l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.72,125.67a7.25,7.25,0,0,0-3.25-5.45l-1.21-.7a7.27,7.27,0,0,0-6.55,0l-61.89,35.77a7.23,7.23,0,0,0-3.27,5.67v30.39a7.21,7.21,0,0,0,3.27,5.66l1.21.7a7.2,7.2,0,0,0,6.55,0l-.28.13,27.15-15.6a7.08,7.08,0,0,1,1.45-.63l5,4.44.38.29,2.74,1.55,5,2.91h0a4,4,0,0,0,3.77-.22c1.41-.82,2.56-3.17,2.56-5.26V173.91a7.22,7.22,0,0,1,3.27-5.67L443.47,162a7.23,7.23,0,0,0,3.27-5.67V125.91A1.94,1.94,0,0,0,446.72,125.67Z",
    style: {
      opacity: 0.25,
      transformOrigin: "408.645px 158.619px"
    },
    className: "animable",
    id: "eliniwam923vh"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.74,125.89c0-2.09-1.46-2.93-3.27-1.89l-61.89,35.77a6.43,6.43,0,0,0-2.05,2l-7.74-4.46a6.34,6.34,0,0,1,2-2l61.89-35.77a7.24,7.24,0,0,1,6.54,0l1.22.7A7.22,7.22,0,0,1,446.74,125.89Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "409.265px 140.265px"
    },
    id: "ell061eay1pwe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els68vz38r3bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.74,125.89c0-2.09-1.46-2.93-3.27-1.89l-61.89,35.77a6.43,6.43,0,0,0-2.05,2l-7.74-4.46a6.34,6.34,0,0,1,2-2l61.89-35.77a7.24,7.24,0,0,1,6.54,0l1.22.7A7.22,7.22,0,0,1,446.74,125.89Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "409.265px 140.265px"
    },
    className: "animable",
    id: "eltnro64uqyg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.12,197.49c-1.06,0-1.17-1.18-1.17-1.69V165.41a6.63,6.63,0,0,1,2.95-5.11l61.89-35.72a2.35,2.35,0,0,1,1.14-.36c1.06,0,1.17,1.18,1.17,1.69V156.3a6.62,6.62,0,0,1-3,5.11l-10.85,6.28a7.83,7.83,0,0,0-3.59,6.22v11.41c0,1.85-1,4-2.24,4.7a3.77,3.77,0,0,1-1.89.51h0a2.23,2.23,0,0,1-1.52-.49l-9.28-8.6a3.12,3.12,0,0,0-2.21-.74,7.16,7.16,0,0,0-3.44,1l-26.87,15.45A2.35,2.35,0,0,1,380.12,197.49Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "412.525px 160.855px"
    },
    id: "eln26rwpw1o4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.93,124.86c.46,0,.53.66.53,1V156.3a6,6,0,0,1-2.63,4.55L432,167.13a8.51,8.51,0,0,0-3.91,6.78v11.41a5.35,5.35,0,0,1-1.91,4.15,3.29,3.29,0,0,1-1.57.42,1.59,1.59,0,0,1-1.07-.31l-9.28-8.6a3.77,3.77,0,0,0-2.66-.92,7.75,7.75,0,0,0-3.76,1.07l-26.87,15.44a1.77,1.77,0,0,1-.82.28c-.46,0-.53-.66-.53-1V165.41a6,6,0,0,1,2.63-4.55l61.89-35.72a1.77,1.77,0,0,1,.82-.28m0-1.28a2.91,2.91,0,0,0-1.46.45l-61.89,35.71a7.25,7.25,0,0,0-3.27,5.67V195.8c0,1.48.73,2.33,1.81,2.33a3,3,0,0,0,1.46-.44l26.87-15.45a6.47,6.47,0,0,1,3.12-.9,2.57,2.57,0,0,1,1.77.56l9.28,8.6a2.79,2.79,0,0,0,2,.67,4.52,4.52,0,0,0,2.21-.59c1.41-.82,2.56-3.17,2.56-5.26V173.91a7.22,7.22,0,0,1,3.27-5.67L443.47,162a7.23,7.23,0,0,0,3.27-5.67V125.91c0-1.48-.74-2.33-1.82-2.33Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "412.54px 160.855px"
    },
    id: "el2e7wxbus0ra",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,148.45c2.08-1.19,3.77-.22,3.77,2.18a8.32,8.32,0,0,1-3.77,6.51c-2.07,1.2-3.76.23-3.76-2.17A8.34,8.34,0,0,1,427.46,148.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "427.465px 152.798px"
    },
    id: "elda0caz3werm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,157.13c2.08-1.2,3.76-.23,3.76,2.17a8.31,8.31,0,0,1-3.76,6.52c-2.08,1.19-3.76.22-3.76-2.18A8.31,8.31,0,0,1,412.42,157.13Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "412.42px 161.472px"
    },
    id: "elzsdw0ayokm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,165.8c2.08-1.2,3.76-.22,3.76,2.18a8.31,8.31,0,0,1-3.76,6.51c-2.07,1.2-3.76.23-3.76-2.17A8.34,8.34,0,0,1,397.37,165.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "397.37px 170.146px"
    },
    id: "elggs9990y9sp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-63",
    className: "animable",
    style: {
      transformOrigin: "334.555px 112.865px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63",
    className: "animable",
    style: {
      transformOrigin: "334.555px 112.865px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-63"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "328.21px 105.823px"
    },
    className: "animable",
    id: "el8p2awciq77n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.22,88.67c0,3.39-2.38,5.55-5.33,7.25L249.53,186.79c-2.93,1.69-5.33.32-5.33-3.08v-59h0a10.63,10.63,0,0,1,5.31-9.19L406.88,24.61a3.56,3.56,0,0,1,5.34,3.08h0Z",
    id: "eld4q0cxezl1a",
    className: "animable",
    style: {
      transformOrigin: "328.21px 105.823px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-63",
    className: "animable",
    style: {
      transformOrigin: "339.51px 115.238px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.6,194.77l-1.21-.7a7.24,7.24,0,0,1-3.28-5.67V125.72a7.23,7.23,0,0,1,3.28-5.67L413.88,29.66a7.24,7.24,0,0,1,6.54,0l1.21.7A7.23,7.23,0,0,1,424.91,36V98.71a7.23,7.23,0,0,1-3.28,5.67L316.31,165.23a14.15,14.15,0,0,0-4.89,5.3L299.3,196.19a12.83,12.83,0,0,1-4.17,4.9c-1.42.81-4,.63-5.84-.41l-.81-.48a7.21,7.21,0,0,1-3.27-5.66V187c0-2.08-1.47-2.93-3.28-1.89l-16.79,9.7A7.24,7.24,0,0,1,258.6,194.77Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "339.51px 115.238px"
    },
    id: "elsso740vo5nc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpvx68yah5oh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.6,194.77l-1.21-.7a7.24,7.24,0,0,1-3.28-5.67V125.72a7.23,7.23,0,0,1,3.28-5.67L413.88,29.66a7.24,7.24,0,0,1,6.54,0l1.21.7A7.23,7.23,0,0,1,424.91,36V98.71a7.23,7.23,0,0,1-3.28,5.67L316.31,165.23a14.15,14.15,0,0,0-4.89,5.3L299.3,196.19a12.83,12.83,0,0,1-4.17,4.9c-1.42.81-4,.63-5.84-.41l-.81-.48a7.21,7.21,0,0,1-3.27-5.66V187c0-2.08-1.47-2.93-3.28-1.89l-16.79,9.7A7.24,7.24,0,0,1,258.6,194.77Z",
    style: {
      opacity: 0.25,
      transformOrigin: "339.51px 115.238px"
    },
    className: "animable",
    id: "elrrqekl2wcxr"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M424.91,36c0-2.09-1.46-2.93-3.27-1.89l-156.5,90.39a6.2,6.2,0,0,0-2,2l-7.75-4.47a6.33,6.33,0,0,1,2-2L413.88,29.66a7.24,7.24,0,0,1,6.54,0l1.22.7A7.22,7.22,0,0,1,424.91,36Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "340.15px 77.6897px"
    },
    id: "elpmialwuxmc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el99vip4ahhln"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.91,36c0-2.09-1.46-2.93-3.27-1.89l-156.5,90.39a6.2,6.2,0,0,0-2,2l-7.75-4.47a6.33,6.33,0,0,1,2-2L413.88,29.66a7.24,7.24,0,0,1,6.54,0l1.22.7A7.22,7.22,0,0,1,424.91,36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.45,
      transformOrigin: "340.15px 77.6897px"
    },
    className: "animable",
    id: "el8gkby030a2h"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.19,200.73a.74.74,0,0,1-.63-.4,2.9,2.9,0,0,1-.35-1.54V182.71c0-1.78-1-3-2.45-3a3.58,3.58,0,0,0-1.79.54l-24.15,13.94a2.31,2.31,0,0,1-1.14.36c-1.06,0-1.17-1.18-1.17-1.69V130.2a6.65,6.65,0,0,1,2.95-5.12L422,34.7a2.29,2.29,0,0,1,1.14-.36c1,0,1.16,1.18,1.16,1.69V98.71a6.62,6.62,0,0,1-2.95,5.11L316,164.67a14.64,14.64,0,0,0-5.15,5.59l-12.12,25.66a12.21,12.21,0,0,1-3.92,4.61A1.22,1.22,0,0,1,294.19,200.73Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "343.405px 117.535px"
    },
    id: "elcugujcii3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.1,35c.45,0,.52.66.52,1.05V98.71a6,6,0,0,1-2.63,4.56L315.66,164.12a15.4,15.4,0,0,0-5.4,5.87l-12.12,25.66a11.78,11.78,0,0,1-3.66,4.33.86.86,0,0,1-.29.11c-.09-.05-.34-.45-.34-1.3V182.71c0-2.13-1.27-3.62-3.09-3.62a4.22,4.22,0,0,0-2.11.62L264.5,193.66a1.67,1.67,0,0,1-.82.27c-.46,0-.53-.66-.53-1.05V130.2a6,6,0,0,1,2.63-4.56l156.5-90.39a1.68,1.68,0,0,1,.82-.27m0-1.29a3.05,3.05,0,0,0-1.47.45L265.14,124.53a7.22,7.22,0,0,0-3.27,5.67v62.68c0,1.48.73,2.34,1.81,2.34a3,3,0,0,0,1.46-.45l24.15-14a3,3,0,0,1,1.47-.44c1.07,0,1.81.85,1.81,2.33v16.08c0,1.6.67,2.58,1.62,2.58a1.9,1.9,0,0,0,.94-.28,12.83,12.83,0,0,0,4.17-4.9l12.12-25.66a14.15,14.15,0,0,1,4.89-5.3l105.32-60.85a7.23,7.23,0,0,0,3.28-5.67V36c0-1.48-.74-2.34-1.81-2.34Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "343.39px 117.49px"
    },
    id: "eloti5ldye9p",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-63",
    className: "animable",
    style: {
      transformOrigin: "345.11px 125.937px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276,148.12V130.47a1.73,1.73,0,0,1,1-1.48l.75-.44q1-.59,1,.3v6.81l3.07-1.77v-6.81a1.71,1.71,0,0,1,1-1.48l.73-.43c.69-.4,1-.31,1,.28v17.66a1.73,1.73,0,0,1-1,1.48l-.73.42c-.7.4-1,.31-1-.28v-7.2l-3.07,1.77v7.2a1.7,1.7,0,0,1-1,1.47l-.75.44C276.36,148.81,276,148.71,276,148.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "280.275px 136.788px"
    },
    id: "elf383jps38yo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.14,141.7V128.93a1.77,1.77,0,0,1,1.07-1.5l.5-.29c.72-.42,1.08-.33,1.08.26v12.77a1.76,1.76,0,0,1-1.08,1.5l-.5.29C287.5,142.38,287.14,142.29,287.14,141.7Zm.12-16.07V124c0-.59.4-1.12,1.2-1.58s1.26-.43,1.26.16v1.65c0,.59-.4,1.12-1.2,1.58S287.26,126.22,287.26,125.63Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "288.465px 132.162px"
    },
    id: "elp7rrlh8ckid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,138.88v-2.54a1.71,1.71,0,0,1,1-1.48l.59-.34c.69-.41,1-.31,1,.28v2.54a1.73,1.73,0,0,1-1,1.48l-.59.34C292.37,139.56,292,139.47,292,138.88Zm.55-5.82c-.13-.07-.19-.26-.19-.57V121a1.73,1.73,0,0,1,1-1.49l.82-.47a1.16,1.16,0,0,1,.76-.23c.19,0,.28.16.28.4l-.91,12.11a2.19,2.19,0,0,1-.22.82,1.8,1.8,0,0,1-.7.59l-.14.09C293,133.05,292.7,133.12,292.58,133.06Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "293.61px 129.106px"
    },
    id: "eltjrmjoxd1wb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,174.18V156.53a1.74,1.74,0,0,1,1-1.49l.75-.43c.68-.39,1-.29,1,.29v6.82l3.07-1.77v-6.82a1.72,1.72,0,0,1,1-1.48l.73-.42c.69-.4,1-.31,1,.28v17.65a1.74,1.74,0,0,1-1,1.49l-.73.42c-.7.4-1,.31-1-.28v-7.2l-3.07,1.77v7.2a1.7,1.7,0,0,1-1,1.47l-.75.43C276.36,174.86,276,174.77,276,174.18Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "280.275px 162.845px"
    },
    id: "elysn755jwu88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.73,166.55c-.62-.92-.93-2.59-.93-5a17.06,17.06,0,0,1,.92-6,6.48,6.48,0,0,1,2.73-3.49c1.21-.69,2.12-.58,2.74.33s.93,2.57.93,5a17.22,17.22,0,0,1-.93,6.07,6.48,6.48,0,0,1-2.74,3.5C289.26,167.58,288.35,167.47,287.73,166.55Zm3.48-4.28a18.2,18.2,0,0,0,.23-3.39,13.9,13.9,0,0,0-.23-3.13c-.15-.54-.39-.71-.74-.51a2,2,0,0,0-.76,1.38,18,18,0,0,0-.23,3.38,14.07,14.07,0,0,0,.23,3.14c.15.55.4.72.76.51A2,2,0,0,0,291.21,162.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "290.46px 159.481px"
    },
    id: "elf26se65kjwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.56,162.49q-.18,0-.21-.33l-1.9-11.72c0-.11,0-.24,0-.41,0-.48.37-.93,1.1-1.35s1.27-.54,1.29-.16l.46,6.54.18,3,.07,0c.07-1.11.17-2.23.29-3.37l.75-7.1a1,1,0,0,1,.28-.59,2.47,2.47,0,0,1,.65-.53l.47-.27a1.28,1.28,0,0,1,.64-.22.25.25,0,0,1,.29.26l.75,6.29c.09.67.18,1.67.27,3l.07,0c0-.27,0-.54.06-.83s0-.54,0-.76l.09-1.57.49-7.09c0-.41.43-.83,1.2-1.28s1.09-.39,1.09.09c0,.17,0,.31,0,.42l-1.86,13.91a1.3,1.3,0,0,1-.74,1l-.57.33a.89.89,0,0,1-.56.18c-.1,0-.17-.14-.19-.32l-1.13-6.61c0-.44-.06-.78-.07-1,0-.54-.05-.87-.07-1l-.08,0c0,.48-.06.85-.07,1.09,0,.59,0,1-.07,1.12l-1.11,7.9a1.1,1.1,0,0,1-.2.55,1.77,1.77,0,0,1-.53.45l-.6.34A.85.85,0,0,1,297.56,162.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "300.695px 153.104px"
    },
    id: "el754fkwl1zbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.18,148.11q0-7.47,3.87-9.71a3.5,3.5,0,0,1,1.24-.46,1.59,1.59,0,0,1,1,.14.79.79,0,0,1,.38.73,6,6,0,0,1-.28,1.45c-.19.64-.36,1-.53,1.11a.42.42,0,0,1-.34,0,4.76,4.76,0,0,0-.58-.07,1.25,1.25,0,0,0-.59.19,2.65,2.65,0,0,0-1.09,1.6,12.41,12.41,0,0,0-.36,3.43,9.1,9.1,0,0,0,.34,3,.66.66,0,0,0,1.06.37,3,3,0,0,0,.59-.48,6.1,6.1,0,0,0,.45-.54l.23-.3a3.16,3.16,0,0,1,.32-.38c.18-.1.36.06.53.48a3,3,0,0,1,.26,1.17,2.36,2.36,0,0,1-.45,1.22,7.35,7.35,0,0,1-1.08,1.32,6.19,6.19,0,0,1-1.15.91Q310.17,155.5,310.18,148.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "313.43px 145.856px"
    },
    id: "elhsq97azd9im",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.64,149.46a4.65,4.65,0,0,1-.63-2.81,8.07,8.07,0,0,1,4.17-7.54v-.44a1.82,1.82,0,0,0-.26-1.16c-.17-.18-.45-.16-.83.06a2.71,2.71,0,0,0-.7.55c-.2.22-.43.49-.68.82a1.68,1.68,0,0,1-.38.44c-.12.07-.25,0-.39-.19a2.77,2.77,0,0,1-.38-.73,2.25,2.25,0,0,1-.16-.75,2.29,2.29,0,0,1,.42-1.14,7.14,7.14,0,0,1,1.09-1.31,7.87,7.87,0,0,1,1.37-1c1.25-.71,2.15-.81,2.71-.29a4.11,4.11,0,0,1,.84,3v5c0,.84,0,1.48.05,1.9s.06.89.11,1.4a3.25,3.25,0,0,1,.06.57c0,.3-.25.66-.73,1.08a7.7,7.7,0,0,1-1.28,1c-.19.11-.33.08-.4-.09a4.52,4.52,0,0,1-.24-.94,7.11,7.11,0,0,1-.74,1.53,3.5,3.5,0,0,1-1.2,1.19C319.67,150,319.07,150,318.64,149.46Zm3.15-3.86a3.43,3.43,0,0,0,.39-.89v-3.23a3.71,3.71,0,0,0-1.79,3.49,2,2,0,0,0,.23,1.1c.16.21.37.24.65.08A1.54,1.54,0,0,0,321.79,145.6Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "321.52px 141.764px"
    },
    id: "el9shamzfiy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.29,144.58v-8.8c0-1.31,0-2.22-.09-2.74s-.09-.84-.09-1a1.81,1.81,0,0,1,.75-1.17,7.87,7.87,0,0,1,1.31-1c.22-.13.37-.11.44.05a2.06,2.06,0,0,1,.16.69c0,.31.05.55.08.72a9.73,9.73,0,0,1,1-2.08,3.93,3.93,0,0,1,1.35-1.37c.66-.38,1.16-.35,1.5.11a4.56,4.56,0,0,1,.51,2.56v10a1.74,1.74,0,0,1-1,1.48l-.61.35c-.69.4-1,.31-1-.28v-9a2.23,2.23,0,0,0-.14-1c-.1-.17-.27-.19-.52,0a2.6,2.6,0,0,0-.89,1.4V143a1.36,1.36,0,0,1-.26.8,2.15,2.15,0,0,1-.77.67l-.62.36C327.63,145.26,327.29,145.17,327.29,144.58Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "330.67px 136.358px"
    },
    id: "elch9jkxf753b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.31,137.64V120a1.74,1.74,0,0,1,1-1.51l.75-.43c.68-.39,1-.29,1,.32V136a1.72,1.72,0,0,1-1,1.5l-.75.44C339.65,138.35,339.31,138.24,339.31,137.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "340.685px 128.006px"
    },
    id: "eluoii96rso0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.33,133V113.92a1.74,1.74,0,0,1,1-1.49l.61-.35c.69-.4,1-.3,1,.28v7.15a8.9,8.9,0,0,1,1-1.9,3.87,3.87,0,0,1,1.28-1.27c.66-.38,1.16-.34,1.5.11a4.44,4.44,0,0,1,.52,2.56v10a1.71,1.71,0,0,1-1,1.48l-.6.35c-.7.4-1,.31-1-.28v-9a2,2,0,0,0-.16-1c-.11-.17-.29-.18-.54,0a2.5,2.5,0,0,0-.88,1.39v9.57a1.76,1.76,0,0,1-1,1.49l-.61.35C347.68,133.69,347.33,133.59,347.33,133Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "350.796px 122.693px"
    },
    id: "elh6hfnevzmeo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.15,126.52c-.66-.86-1-2.5-1-4.9a16.64,16.64,0,0,1,1-6.37,6.72,6.72,0,0,1,2.75-3.32c1.17-.67,2-.53,2.55.44a11.57,11.57,0,0,1,.78,5.06,3.8,3.8,0,0,1-.36,1.19,2.59,2.59,0,0,1-.55,1l-3.4,2a2.79,2.79,0,0,0,.41,1.76c.25.25.59.25,1,0a3.59,3.59,0,0,0,.72-.58c.21-.24.42-.49.62-.77a3.08,3.08,0,0,1,.38-.45c.12-.07.25,0,.4.17a2.26,2.26,0,0,1,.38.69,2.2,2.2,0,0,1,.15.7,2.41,2.41,0,0,1-.48,1.34,7.39,7.39,0,0,1-1.14,1.31,6.56,6.56,0,0,1-1.16.88C358.83,127.42,357.81,127.38,357.15,126.52Zm3.66-8.52a11.06,11.06,0,0,0-.22-2.68c-.14-.47-.38-.62-.72-.42a1.9,1.9,0,0,0-.74,1.22,15.1,15.1,0,0,0-.33,3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "359.698px 119.358px"
    },
    id: "elvwoq4c1472",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,119.64V103.7a1.79,1.79,0,0,1,1.08-1.51l.5-.29c.72-.41,1.07-.32,1.07.27v16a1.46,1.46,0,0,0,.1.64q.11.17.33,0a1.2,1.2,0,0,0,.2-.17,1.12,1.12,0,0,1,.2-.17c.15-.09.28.08.38.51a6,6,0,0,1,.14,1.23,2,2,0,0,1-.53,1.28,4.28,4.28,0,0,1-1.16,1Q365,123.84,365,119.64Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "367px 112.233px"
    },
    id: "el6fwhx4kwz1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.35,125.34V111c0-.85,0-1.48,0-1.89s-.07-.88-.12-1.38a5,5,0,0,1-.05-.55c0-.29.24-.66.72-1.08a7.72,7.72,0,0,1,1.29-1c.23-.14.4-.09.49.15a5.8,5.8,0,0,1,.24,1.11,7.06,7.06,0,0,1,.77-1.84,3.26,3.26,0,0,1,1.13-1.19,1.09,1.09,0,0,1,1.39.07,3.86,3.86,0,0,1,.95,2,17.74,17.74,0,0,1,.35,3.87,19.1,19.1,0,0,1-.79,5.9,5.49,5.49,0,0,1-2.2,3.19,1.23,1.23,0,0,1-1.47.05v5.38a1.76,1.76,0,0,1-1.08,1.5l-.5.29C370.71,126,370.35,125.93,370.35,125.34Zm4.18-11.2a16.56,16.56,0,0,0,.25-3.38,13.38,13.38,0,0,0-.22-3c-.14-.57-.37-.76-.68-.58a2.64,2.64,0,0,0-.87,1.61v6.82a.74.74,0,0,0,.73,0A2.13,2.13,0,0,0,374.53,114.14Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "373.848px 114.48px"
    },
    id: "elgo7vstvmrc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.68,96.09q0,.1,0,.51l-3,20.24a1.74,1.74,0,0,1-1,1.15l-.35.2c-.67.39-1,.39-1,0a3.16,3.16,0,0,1,.06-.52l1-6.38a.69.69,0,0,1-.42.11q-.15,0-.21-.33l-2.08-10.28a4.55,4.55,0,0,1-.07-.56c0-.42.3-.81.9-1.15l.77-.45a1.39,1.39,0,0,1,.63-.24c.15,0,.24.11.28.35l.66,5.22c.07.62.17,1.59.29,2.92l.07,0c.06-.68.1-1.12.13-1.32q.11-1.38.18-2l.71-6.06a1.65,1.65,0,0,1,.95-1.13l.52-.3C388.33,95.68,388.68,95.68,388.68,96.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "385.145px 107.131px"
    },
    id: "elmffhbtumza",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.74,107.07c-.62-.92-.93-2.58-.93-5a17.31,17.31,0,0,1,.92-6,6.54,6.54,0,0,1,2.73-3.48c1.21-.7,2.12-.59,2.75.32s.93,2.57.93,5a17.26,17.26,0,0,1-.93,6.07,6.54,6.54,0,0,1-2.75,3.5C392.27,108.11,391.36,108,390.74,107.07Zm3.49-4.27a19.41,19.41,0,0,0,.22-3.4,14.7,14.7,0,0,0-.22-3.12q-.23-.81-.75-.51a1.93,1.93,0,0,0-.76,1.37,18.33,18.33,0,0,0-.22,3.39,14.32,14.32,0,0,0,.22,3.14c.15.55.4.72.76.51A2,2,0,0,0,394.23,102.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "393.476px 100.006px"
    },
    id: "elh24cshccjma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,103a4.27,4.27,0,0,1-.53-2.55v-10a1.71,1.71,0,0,1,1-1.48l.61-.35c.69-.4,1-.31,1,.28v9.1a2.11,2.11,0,0,0,.14,1c.09.18.27.19.52,0a2.64,2.64,0,0,0,.89-1.4v-9.6a1.42,1.42,0,0,1,.26-.81,2.29,2.29,0,0,1,.76-.66l.63-.36c.68-.4,1-.3,1,.29v8.8q0,2,.09,2.76c.06.54.09.87.09,1,0,.33-.25.71-.75,1.15a8.16,8.16,0,0,1-1.31,1c-.22.13-.37.12-.45,0a2.38,2.38,0,0,1-.15-.7c0-.3-.05-.54-.08-.71a10.28,10.28,0,0,1-1,2.06,3.72,3.72,0,0,1-1.3,1.34C400.42,103.43,399.9,103.4,399.55,103Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "402.503px 94.6328px"
    },
    id: "elyyzuc077cue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.24,91.79c-.14,0-.21-.21-.21-.5a10.88,10.88,0,0,1,.26-2.33,19.16,19.16,0,0,1,.76-2.48l.4-1c.33-.8.57-1.42.72-1.88a3.81,3.81,0,0,0,.23-1.15q0-1.55-1.17-.87a2.37,2.37,0,0,0-.64.55q-.29.34-.57.75a1.65,1.65,0,0,1-.35.45c-.15.09-.32.05-.49-.14a2.61,2.61,0,0,1-.45-.72,2.06,2.06,0,0,1-.18-.75,2.78,2.78,0,0,1,.47-1.46,7.58,7.58,0,0,1,1.18-1.45,7.4,7.4,0,0,1,1.39-1.08c1.1-.63,2-.73,2.63-.29s1,1.4,1,2.87a9.67,9.67,0,0,1-.2,2,10.38,10.38,0,0,1-.51,1.65c-.19.48-.46,1.08-.81,1.79a21,21,0,0,0-.95,2.18,8.09,8.09,0,0,0-.45,2,1.71,1.71,0,0,1-.28.74,2.27,2.27,0,0,1-.67.55l-.41.24A1,1,0,0,1,409.24,91.79Zm-.44,5.73V95a1.79,1.79,0,0,1,1.08-1.51l.57-.33c.71-.41,1.07-.32,1.07.27v2.53a1.79,1.79,0,0,1-1.07,1.51l-.57.33C409.16,98.19,408.8,98.11,408.8,97.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "410.885px 87.6052px"
    },
    id: "ela2hptishapu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-63",
    className: "animable",
    style: {
      transformOrigin: "162.673px 243.827px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-63",
    className: "animable",
    style: {
      transformOrigin: "229.864px 431.353px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M204.21,473.18a4.13,4.13,0,0,1-4-3.31l-.67-3.57a44.94,44.94,0,0,1-4.54-1.12l-6.93,3.21a4.75,4.75,0,0,1-2,.41,4.8,4.8,0,0,1-2.37-.61l-7.1-4.09a3.52,3.52,0,0,1-.3-6l3.72-2.67c-.18-.26-.34-.52-.5-.78l-8.67-.55a4,4,0,0,1-3.69-3.93v-5.28a4,4,0,0,1,3.7-3.93l8.66-.55c.16-.26.32-.52.5-.77L176.34,437a3.51,3.51,0,0,1,.3-6l7.1-4.1a4.8,4.8,0,0,1,2.37-.61,4.72,4.72,0,0,1,2,.42l6.93,3.21a41.83,41.83,0,0,1,4.54-1.13l.67-3.57a4.14,4.14,0,0,1,4-3.31h10.43a4.14,4.14,0,0,1,4,3.32l.68,3.56a43,43,0,0,1,4.54,1.13l6.93-3.21a4.67,4.67,0,0,1,2-.42,4.81,4.81,0,0,1,2.38.61l7.09,4.1a3.51,3.51,0,0,1,.3,6l-3.72,2.68c.18.25.35.51.5.77L248,441a4,4,0,0,1,3.69,3.93v5.28A4,4,0,0,1,248,454.1l-8.67.55c-.15.26-.32.52-.5.78l3.72,2.67a3.52,3.52,0,0,1-.3,6l-7.09,4.09a4.81,4.81,0,0,1-2.38.61h0a4.67,4.67,0,0,1-2-.41l-6.93-3.21a45.61,45.61,0,0,1-4.54,1.12l-.68,3.57a4.13,4.13,0,0,1-4,3.31Zm5.22-32.43a21.63,21.63,0,0,0-10.49,2.46c-2.2,1.27-3.46,2.85-3.46,4.32s1.26,3.05,3.46,4.32a23.49,23.49,0,0,0,21,0c2.2-1.27,3.46-2.84,3.46-4.32s-1.26-3-3.46-4.32A21.59,21.59,0,0,0,209.43,440.75Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "209.425px 447.545px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.71,427.41l-7.09-4.09a1.88,1.88,0,0,0-1.57-.07l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H204.21a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.7,2.7,0,0,1-1.64-.1l-7.2-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.59.59,0,0,0-.33.49h0l0,6.15h0a.59.59,0,0,0,.29.48l3.26,2.35a1.54,1.54,0,0,1-.81.33l-9.45.6a1,1,0,0,0-.88.94v4h0l0,7.4a1,1,0,0,0,.89.94l9.45.6a1.51,1.51,0,0,1,.82.34l-3.25,2.34a.57.57,0,0,0-.28.47h0l0,6.16h0a.63.63,0,0,0,.33.48l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.71,2.71,0,0,1,1.64-.1,43.65,43.65,0,0,0,5.58,1.33,1.34,1.34,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1-.87l.9-4.74a1.36,1.36,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.73,2.73,0,0,1,1.65.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09A.57.57,0,0,0,241,461h0v-6.17h0a.57.57,0,0,0-.28-.47L237.5,452a1.51,1.51,0,0,1,.8-.33l9.45-.6a1,1,0,0,0,.89-.94V438.74a1,1,0,0,0-.88-.94l-9.45-.6a1.51,1.51,0,0,1-.82-.34l3.24-2.34a.57.57,0,0,0,.28-.47h0V427.9h0A.59.59,0,0,0,240.71,427.41Zm-47.88,15.94c.5-1.7,2-3.37,4.61-4.86,6.62-3.82,17.35-3.82,24,0a10.87,10.87,0,0,1,4.72,4.52c-.56,1.94-2.13,3.8-4.72,5.29-6.62,3.82-17.35,3.82-24,0A9.79,9.79,0,0,1,192.83,443.35Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "209.45px 444.445px"
    },
    id: "el8t9v2i4z1pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr0jhqi1235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.71,427.41l-7.09-4.09a1.88,1.88,0,0,0-1.57-.07l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H204.21a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.7,2.7,0,0,1-1.64-.1l-7.2-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.59.59,0,0,0-.33.49h0l0,6.15h0a.59.59,0,0,0,.29.48l3.26,2.35a1.54,1.54,0,0,1-.81.33l-9.45.6a1,1,0,0,0-.88.94v4h0l0,7.4a1,1,0,0,0,.89.94l9.45.6a1.51,1.51,0,0,1,.82.34l-3.25,2.34a.57.57,0,0,0-.28.47h0l0,6.16h0a.63.63,0,0,0,.33.48l7.1,4.09a1.87,1.87,0,0,0,1.57.07l7.19-3.33a2.71,2.71,0,0,1,1.64-.1,43.65,43.65,0,0,0,5.58,1.33,1.34,1.34,0,0,1,1,1l.9,4.74a1.13,1.13,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1-.87l.9-4.74a1.36,1.36,0,0,1,1-1,43.25,43.25,0,0,0,5.58-1.33,2.73,2.73,0,0,1,1.65.1l7.19,3.33a1.87,1.87,0,0,0,1.57-.07l7.09-4.09A.57.57,0,0,0,241,461h0v-6.17h0a.57.57,0,0,0-.28-.47L237.5,452a1.51,1.51,0,0,1,.8-.33l9.45-.6a1,1,0,0,0,.89-.94V438.74a1,1,0,0,0-.88-.94l-9.45-.6a1.51,1.51,0,0,1-.82-.34l3.24-2.34a.57.57,0,0,0,.28-.47h0V427.9h0A.59.59,0,0,0,240.71,427.41Zm-47.88,15.94c.5-1.7,2-3.37,4.61-4.86,6.62-3.82,17.35-3.82,24,0a10.87,10.87,0,0,1,4.72,4.52c-.56,1.94-2.13,3.8-4.72,5.29-6.62,3.82-17.35,3.82-24,0A9.79,9.79,0,0,1,192.83,443.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "209.45px 444.445px"
    },
    className: "animable",
    id: "elsd83e3gljn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfji25h5h7iv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.81,446.4a1.77,1.77,0,0,0-1.28-.85l-9.45-.59a1,1,0,0,1-.88-.94v-1.25l0,7.39a1,1,0,0,0,.88.95l9.46.59a1.56,1.56,0,0,1,.83.35l2.37-1.71a.75.75,0,0,0,.1-1.15A14.19,14.19,0,0,1,181.81,446.4Zm-4-12.35h0a.55.55,0,0,0,.28.47l3.26,2.35a1.51,1.51,0,0,0,.47-.51,14.19,14.19,0,0,1,2-2.79.74.74,0,0,0-.11-1.15l-5.62-4a.68.68,0,0,1-.28-.42Z",
    style: {
      opacity: 0.1,
      transformOrigin: "177.131px 440.025px"
    },
    className: "animable",
    id: "el6vmnir7t3q"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhe7jij4i9w4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.41,434.46c-6.62-3.82-17.35-3.82-24,0-4.18,2.42-5.72,5.78-4.62,8.89.5-1.7,2-3.36,4.62-4.86,6.62-3.83,17.35-3.82,24,0a11,11,0,0,1,4.73,4.52C227,440,225.43,436.79,221.41,434.46Z",
    style: {
      opacity: 0.1,
      transformOrigin: "209.407px 437.472px"
    },
    className: "animable",
    id: "el6ws1049edj5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.65,444.14a1,1,0,0,1-.88.82l-9.45.6a1.13,1.13,0,0,0-.47.12l0,6.16a1.45,1.45,0,0,1,.47-.13l9.45-.6a1,1,0,0,0,.89-.94ZM241,427.89h0a.46.46,0,0,1,0,.19.38.38,0,0,1-.11.18.69.69,0,0,1-.13.11l-5.62,4.05a.41.41,0,0,0-.14.12.84.84,0,0,0-.18.35.88.88,0,0,0,0,.23.37.37,0,0,0,0,.12,1.09,1.09,0,0,0,.19.33.69.69,0,0,1,.11.13,13.84,13.84,0,0,1,1.9,2.65,1.8,1.8,0,0,0,.45.51l3.25-2.33a.58.58,0,0,0,.28-.48h0Zm0,27a.61.61,0,0,1-.33.43l-7.1,4.09a1.9,1.9,0,0,1-1.1.2v6.14a1.89,1.89,0,0,0,1.1-.19l7.09-4.09A.61.61,0,0,0,241,461ZM194.7,456a2.18,2.18,0,0,0-.71.17l-7.19,3.33a1.44,1.44,0,0,1-.64.14v6.14a1.62,1.62,0,0,0,.64-.13l7.19-3.33a2.18,2.18,0,0,1,.7-.16Zm20.82,7.55a1.1,1.1,0,0,1-.88.47H204.21a1.06,1.06,0,0,1-.64-.23V470a1.09,1.09,0,0,0,.64.23h10.42a1.1,1.1,0,0,0,.91-.53Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "217.41px 449.06px"
    },
    id: "el7gnkq4d25di",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqjsfal8qpa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.65,444.14a1,1,0,0,1-.88.82l-9.45.6a1.13,1.13,0,0,0-.47.12l0,6.16a1.45,1.45,0,0,1,.47-.13l9.45-.6a1,1,0,0,0,.89-.94ZM241,427.89h0a.46.46,0,0,1,0,.19.38.38,0,0,1-.11.18.69.69,0,0,1-.13.11l-5.62,4.05a.41.41,0,0,0-.14.12.84.84,0,0,0-.18.35.88.88,0,0,0,0,.23.37.37,0,0,0,0,.12,1.09,1.09,0,0,0,.19.33.69.69,0,0,1,.11.13,13.84,13.84,0,0,1,1.9,2.65,1.8,1.8,0,0,0,.45.51l3.25-2.33a.58.58,0,0,0,.28-.48h0Zm0,27a.61.61,0,0,1-.33.43l-7.1,4.09a1.9,1.9,0,0,1-1.1.2v6.14a1.89,1.89,0,0,0,1.1-.19l7.09-4.09A.61.61,0,0,0,241,461ZM194.7,456a2.18,2.18,0,0,0-.71.17l-7.19,3.33a1.44,1.44,0,0,1-.64.14v6.14a1.62,1.62,0,0,0,.64-.13l7.19-3.33a2.18,2.18,0,0,1,.7-.16Zm20.82,7.55a1.1,1.1,0,0,1-.88.47H204.21a1.06,1.06,0,0,1-.64-.23V470a1.09,1.09,0,0,0,.64.23h10.42a1.1,1.1,0,0,0,.91-.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "217.41px 449.06px"
    },
    className: "animable",
    id: "el62xo22dllv"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M232.05,423.25l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H204.21a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.7,2.7,0,0,1-1.64-.1l-7.2-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0,0,1l5.63,4.05a.75.75,0,0,1,.1,1.15,14.19,14.19,0,0,0-2,2.79,1.73,1.73,0,0,1-1.28.84l-9.45.6a1,1,0,0,0-.88.94V444a1,1,0,0,0,.88.94l9.45.6a1.75,1.75,0,0,1,1.28.84,14.19,14.19,0,0,0,2,2.79.74.74,0,0,1-.11,1.15l-5.62,4.05a.53.53,0,0,0,0,1l7.09,4.09a1.88,1.88,0,0,0,1.57.07l7.19-3.33a2.74,2.74,0,0,1,1.65-.1,41.66,41.66,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,41.66,41.66,0,0,0,5.58-1.33,2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.88,1.88,0,0,0,1.57-.07l7.09-4.09a.53.53,0,0,0,0-1l-5.62-4.05a.74.74,0,0,1-.11-1.15,14.44,14.44,0,0,0,2-2.78,1.74,1.74,0,0,1,1.28-.85l9.45-.6a1,1,0,0,0,.88-.94v-5.28a1,1,0,0,0-.88-.94l-9.45-.6a1.73,1.73,0,0,1-1.28-.84,14.19,14.19,0,0,0-2-2.79.74.74,0,0,1,.11-1.15l5.62-4.05a.53.53,0,0,0,0-1l-7.09-4.09A1.88,1.88,0,0,0,232.05,423.25Zm-10.64,11.21c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S214.79,430.64,221.41,434.46Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "209.425px 441.39px"
    },
    id: "elai0rbemydvv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcyqve0xbk89"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "209.46px 441.42px"
    },
    className: "animable",
    id: "eljbtc09nm0bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.05,423.25l-7.19,3.33a2.74,2.74,0,0,1-1.65.1,43.25,43.25,0,0,0-5.58-1.33,1.36,1.36,0,0,1-1-1l-.9-4.74a1.11,1.11,0,0,0-1.05-.87H204.21a1.11,1.11,0,0,0-1.05.87l-.9,4.74a1.36,1.36,0,0,1-1,1,43.25,43.25,0,0,0-5.58,1.33,2.7,2.7,0,0,1-1.64-.1l-7.2-3.33a1.88,1.88,0,0,0-1.57.07l-7.09,4.09a.53.53,0,0,0,0,1l5.63,4.05a.75.75,0,0,1,.1,1.15,14.19,14.19,0,0,0-2,2.79,1.73,1.73,0,0,1-1.28.84l-9.45.6a1,1,0,0,0-.88.94V444a1,1,0,0,0,.88.94l9.45.6a1.75,1.75,0,0,1,1.28.84,14.19,14.19,0,0,0,2,2.79.74.74,0,0,1-.11,1.15l-5.62,4.05a.53.53,0,0,0,0,1l7.09,4.09a1.88,1.88,0,0,0,1.57.07l7.19-3.33a2.74,2.74,0,0,1,1.65-.1,41.66,41.66,0,0,0,5.58,1.33,1.36,1.36,0,0,1,1,1l.9,4.74a1.11,1.11,0,0,0,1.05.87h10.43a1.11,1.11,0,0,0,1.05-.87l.9-4.74a1.36,1.36,0,0,1,1-1,41.66,41.66,0,0,0,5.58-1.33,2.74,2.74,0,0,1,1.65.1l7.19,3.33a1.88,1.88,0,0,0,1.57-.07l7.09-4.09a.53.53,0,0,0,0-1l-5.62-4.05a.74.74,0,0,1-.11-1.15,14.44,14.44,0,0,0,2-2.78,1.74,1.74,0,0,1,1.28-.85l9.45-.6a1,1,0,0,0,.88-.94v-5.28a1,1,0,0,0-.88-.94l-9.45-.6a1.73,1.73,0,0,1-1.28-.84,14.19,14.19,0,0,0-2-2.79.74.74,0,0,1,.11-1.15l5.62-4.05a.53.53,0,0,0,0-1l-7.09-4.09A1.88,1.88,0,0,0,232.05,423.25Zm-10.64,11.21c6.62,3.82,6.62,10,0,13.84s-17.35,3.82-24,0-6.62-10,0-13.84S214.79,430.64,221.41,434.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.425px 441.39px"
    },
    id: "elnthz6irsgsb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.64,464.38H204.21a1.45,1.45,0,0,1-1.39-1.16l-.9-4.73a1,1,0,0,0-.76-.74,43.54,43.54,0,0,1-5.62-1.33,2.23,2.23,0,0,0-1.4.08L187,459.83a2.27,2.27,0,0,1-1.89-.09L178,455.65a.88.88,0,0,1-.08-1.55l5.62-4a.4.4,0,0,0,.18-.29.45.45,0,0,0-.13-.35,13.92,13.92,0,0,1-2.05-2.85,1.44,1.44,0,0,0-1-.67l-9.45-.59a1.31,1.31,0,0,1-1.21-1.29v-5.28a1.3,1.3,0,0,1,1.21-1.28l9.45-.6a1.44,1.44,0,0,0,1-.67,13.92,13.92,0,0,1,2.05-2.85.45.45,0,0,0,.13-.35.4.4,0,0,0-.18-.29l-5.62-4a.88.88,0,0,1,.08-1.55l7.09-4.09a2.27,2.27,0,0,1,1.89-.09l7.19,3.33a2.23,2.23,0,0,0,1.4.08,43.54,43.54,0,0,1,5.62-1.33,1,1,0,0,0,.76-.73l.9-4.74a1.45,1.45,0,0,1,1.39-1.16h10.43a1.45,1.45,0,0,1,1.39,1.16l.9,4.74a1,1,0,0,0,.76.73,42.1,42.1,0,0,1,5.63,1.34,2.27,2.27,0,0,0,1.39-.09l7.19-3.33a2.27,2.27,0,0,1,1.89.09l7.09,4.09a.88.88,0,0,1,.08,1.55l-5.62,4a.4.4,0,0,0-.18.29.45.45,0,0,0,.13.35,14.37,14.37,0,0,1,2.06,2.85,1.42,1.42,0,0,0,1,.67l9.45.6a1.3,1.3,0,0,1,1.21,1.28V444a1.31,1.31,0,0,1-1.21,1.29l-9.45.59a1.42,1.42,0,0,0-1,.67,14.37,14.37,0,0,1-2.06,2.85.45.45,0,0,0-.13.35.4.4,0,0,0,.18.29l5.62,4a1,1,0,0,1,.43.8.93.93,0,0,1-.51.75l-7.09,4.09a2.27,2.27,0,0,1-1.89.09l-7.19-3.33a2.2,2.2,0,0,0-1.39-.08,44.1,44.1,0,0,1-5.63,1.33,1,1,0,0,0-.76.74l-.9,4.73A1.45,1.45,0,0,1,214.64,464.38ZM195,455.65a2.59,2.59,0,0,1,.76.1,42.31,42.31,0,0,0,5.54,1.32,1.68,1.68,0,0,1,1.32,1.29l.9,4.73a.77.77,0,0,0,.71.59h10.43a.77.77,0,0,0,.71-.59l.9-4.73a1.71,1.71,0,0,1,1.32-1.29,42.31,42.31,0,0,0,5.54-1.32,3,3,0,0,1,1.89.12l7.19,3.33a1.55,1.55,0,0,0,1.25-.06l7.1-4.09c.09-.06.15-.13.15-.18a.24.24,0,0,0-.13-.2l-5.63-4a1.14,1.14,0,0,1-.46-.79,1.09,1.09,0,0,1,.31-.89,13.22,13.22,0,0,0,1.95-2.71,2.1,2.1,0,0,1,1.56-1l9.46-.6a.61.61,0,0,0,.56-.59v-5.28a.61.61,0,0,0-.56-.59l-9.45-.6a2.1,2.1,0,0,1-1.57-1,13.22,13.22,0,0,0-1.95-2.71,1.13,1.13,0,0,1-.31-.89,1.1,1.1,0,0,1,.46-.78l5.63-4.05c.09-.06.14-.14.13-.19s-.06-.13-.15-.19l-7.1-4.09a1.55,1.55,0,0,0-1.25-.06L225,426.89a3,3,0,0,1-1.89.12,42.31,42.31,0,0,0-5.54-1.32,1.71,1.71,0,0,1-1.32-1.28l-.9-4.74a.77.77,0,0,0-.71-.59H204.21a.77.77,0,0,0-.71.59l-.9,4.74a1.7,1.7,0,0,1-1.32,1.28,42.31,42.31,0,0,0-5.54,1.32,3,3,0,0,1-1.89-.11l-7.19-3.34a1.6,1.6,0,0,0-1.25.06l-7.1,4.09c-.09.06-.15.13-.15.19s.05.13.14.19l5.62,4.05a1.07,1.07,0,0,1,.46.78,1.12,1.12,0,0,1-.3.89,13.66,13.66,0,0,0-2,2.71,2.1,2.1,0,0,1-1.56,1l-9.46.6a.61.61,0,0,0-.55.59V444a.61.61,0,0,0,.55.59l9.46.6a2.1,2.1,0,0,1,1.56,1,13.66,13.66,0,0,0,2,2.71,1.12,1.12,0,0,1-.16,1.68l-5.62,4c-.09.06-.15.14-.14.2s.06.12.15.18l7.1,4.09a1.55,1.55,0,0,0,1.25.06l7.19-3.33A2.68,2.68,0,0,1,195,455.65Zm14.45-4.15a24.79,24.79,0,0,1-12.16-2.9c-3.31-1.91-5.14-4.48-5.14-7.22s1.83-5.31,5.14-7.22c6.7-3.87,17.61-3.87,24.31,0h0c3.32,1.91,5.14,4.48,5.14,7.22s-1.82,5.31-5.14,7.22A24.78,24.78,0,0,1,209.43,451.5Zm0-19.56a24.13,24.13,0,0,0-11.81,2.82c-3.09,1.79-4.79,4.14-4.79,6.62s1.7,4.83,4.79,6.62c6.51,3.76,17.1,3.76,23.62,0,3.08-1.79,4.79-4.14,4.79-6.62s-1.71-4.83-4.79-6.62A24.18,24.18,0,0,0,209.43,431.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "209.46px 441.42px"
    },
    id: "eluiasngpc76",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-63",
    d: "M260.7,429.67a3.17,3.17,0,0,1-.44,0L254.1,429a4.07,4.07,0,0,1-3.62-4.54l.11-1c-.52-.18-1-.39-1.52-.6,0,0,0,0,0,0H249l-4.68,1.46a4.69,4.69,0,0,1-1.42.21,5.17,5.17,0,0,1-3.28-1.14l-3.14-2.61a3.66,3.66,0,0,1,.7-6.18l1.07-.53-2.88-.5a3.93,3.93,0,0,1-3.11-5.08l.85-2.72a4.54,4.54,0,0,1,4.24-3.11l5.23.21-.68-.72a3.69,3.69,0,0,1,1.34-6l4.93-2a4.77,4.77,0,0,1,1.83-.34,5.24,5.24,0,0,1,2.87.82l3.19,2.12h0c.92-.15,1.86-.28,2.8-.36l.95-1.85a4.73,4.73,0,0,1,4.13-2.5l.45,0,6.15.64a4.09,4.09,0,0,1,3.62,4.55l-.11.95c.52.19,1,.39,1.52.6,0,0,0,0,0,0h.07l4.68-1.46a4.67,4.67,0,0,1,1.41-.21,5.23,5.23,0,0,1,3.29,1.14l3.14,2.62a3.65,3.65,0,0,1-.71,6.18l-1.06.53,2.88.49a3.93,3.93,0,0,1,3.11,5.08l-.85,2.73a4.55,4.55,0,0,1-4.24,3.1l-5.23-.21.67.72a3.68,3.68,0,0,1-1.33,6l-4.93,2a5,5,0,0,1-1.83.34,5.25,5.25,0,0,1-2.87-.83L268.61,425h0c-.92.16-1.86.28-2.81.36l-.95,1.86A4.72,4.72,0,0,1,260.7,429.67Zm1.62-22.58a15.14,15.14,0,0,0-5.57,1c-2.17.86-3.06,2-3.17,2.65s.59,1.36,1,1.71c1.65,1.37,4.62,2.22,7.75,2.22a15,15,0,0,0,5.58-1c2.16-.86,3.06-2,3.16-2.64s-.58-1.36-1-1.71C268.43,407.94,265.46,407.09,262.32,407.09Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "262.32px 410.859px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.85,395.52a1.34,1.34,0,0,1-.92-1.39l.28-2.34a1.07,1.07,0,0,0-.95-1.2L264.1,390a1.73,1.73,0,0,0-1.59.86l-1.22,2.39a2.17,2.17,0,0,1-1.6,1q-1.6.12-3.18.39a3.12,3.12,0,0,1-2-.39l-3.31-2.2a2.3,2.3,0,0,0-1.93-.2l-4.92,2a.72.72,0,0,0-.51.63h0v.06h0v5h0a.78.78,0,0,0,.24.55l.28.31a2.7,2.7,0,0,1-1.35.42l-5.63-.23a1.51,1.51,0,0,0-1.42,1l-.85,2.72a.8.8,0,0,0,0,.34h0v5.08h0a.92.92,0,0,0,.79.89l4.36.74-1.7.86a.7.7,0,0,0-.44.61h0v5.09h0a.76.76,0,0,0,.3.57l3.15,2.61a2.18,2.18,0,0,0,1.88.37l4.79-1.5a3.39,3.39,0,0,1,2,.14,25.18,25.18,0,0,0,2.57.94,1.34,1.34,0,0,1,.63.45v3.43h0a1.07,1.07,0,0,0,1,1.05l6.15.64a1.69,1.69,0,0,0,1.59-.86l1.23-2.39a2.14,2.14,0,0,1,1.59-1c1.07-.09,2.14-.22,3.19-.4a3.16,3.16,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.51-.65h0V417h0a.84.84,0,0,0-.24-.55l-.29-.3a2.54,2.54,0,0,1,1.36-.42l5.62.22a1.49,1.49,0,0,0,1.42-1l.86-2.72a1.1,1.1,0,0,0,0-.31h0v-5.05h0a.91.91,0,0,0-.79-.94l-4.35-.75,1.69-.85a.72.72,0,0,0,.45-.63h0v-5.06h0a.74.74,0,0,0-.31-.58l-3.14-2.62a2.27,2.27,0,0,0-1.89-.37l-4.79,1.5a3.36,3.36,0,0,1-2-.13A25.21,25.21,0,0,0,271.85,395.52Zm-20.42,12.75a9.11,9.11,0,0,1,4.2-3c5.34-2.14,12.66-1.37,16.37,1.71a7.59,7.59,0,0,1,1.25,1.32,9.17,9.17,0,0,1-4.21,3.06c-5.34,2.13-12.67,1.37-16.37-1.71A7,7,0,0,1,251.43,408.27Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "262.346px 408.311px"
    },
    id: "elhnw845k2ks",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhu5o14oeskg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.85,395.52a1.34,1.34,0,0,1-.92-1.39l.28-2.34a1.07,1.07,0,0,0-.95-1.2L264.1,390a1.73,1.73,0,0,0-1.59.86l-1.22,2.39a2.17,2.17,0,0,1-1.6,1q-1.6.12-3.18.39a3.12,3.12,0,0,1-2-.39l-3.31-2.2a2.3,2.3,0,0,0-1.93-.2l-4.92,2a.72.72,0,0,0-.51.63h0v.06h0v5h0a.78.78,0,0,0,.24.55l.28.31a2.7,2.7,0,0,1-1.35.42l-5.63-.23a1.51,1.51,0,0,0-1.42,1l-.85,2.72a.8.8,0,0,0,0,.34h0v5.08h0a.92.92,0,0,0,.79.89l4.36.74-1.7.86a.7.7,0,0,0-.44.61h0v5.09h0a.76.76,0,0,0,.3.57l3.15,2.61a2.18,2.18,0,0,0,1.88.37l4.79-1.5a3.39,3.39,0,0,1,2,.14,25.18,25.18,0,0,0,2.57.94,1.34,1.34,0,0,1,.63.45v3.43h0a1.07,1.07,0,0,0,1,1.05l6.15.64a1.69,1.69,0,0,0,1.59-.86l1.23-2.39a2.14,2.14,0,0,1,1.59-1c1.07-.09,2.14-.22,3.19-.4a3.16,3.16,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.51-.65h0V417h0a.84.84,0,0,0-.24-.55l-.29-.3a2.54,2.54,0,0,1,1.36-.42l5.62.22a1.49,1.49,0,0,0,1.42-1l.86-2.72a1.1,1.1,0,0,0,0-.31h0v-5.05h0a.91.91,0,0,0-.79-.94l-4.35-.75,1.69-.85a.72.72,0,0,0,.45-.63h0v-5.06h0a.74.74,0,0,0-.31-.58l-3.14-2.62a2.27,2.27,0,0,0-1.89-.37l-4.79,1.5a3.36,3.36,0,0,1-2-.13A25.21,25.21,0,0,0,271.85,395.52Zm-20.42,12.75a9.11,9.11,0,0,1,4.2-3c5.34-2.14,12.66-1.37,16.37,1.71a7.59,7.59,0,0,1,1.25,1.32,9.17,9.17,0,0,1-4.21,3.06c-5.34,2.13-12.67,1.37-16.37-1.71A7,7,0,0,1,251.43,408.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "262.346px 408.311px"
    },
    className: "animable",
    id: "elo9slgm7x628"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elotzg3psqllo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.53,407.7a1.84,1.84,0,0,0-1.3-1.25l-5.36-.92a.91.91,0,0,1-.79-.83v5a.92.92,0,0,0,.79.89l4.36.75,2.25-1.14a1.06,1.06,0,0,0,.45-1.45A7.63,7.63,0,0,1,242.53,407.7Zm1.31-8.17h0a.87.87,0,0,0,.23.56l.29.3a2,2,0,0,0,.47-.36,12.25,12.25,0,0,1,1.35-1.2,1,1,0,0,0,.14-1.44L244.09,395a.75.75,0,0,1-.24-.55Z",
    style: {
      opacity: 0.1,
      transformOrigin: "240.821px 402.895px"
    },
    className: "animable",
    id: "elq7jg4gx4jsi"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elm0k160clq6i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.63,400.16c-4.6,1.85-6.23,5.24-4.2,8.11a9.13,9.13,0,0,1,4.2-3c5.34-2.14,12.66-1.38,16.37,1.71a6.85,6.85,0,0,1,1.24,1.32c1.43-2,1.1-4.45-1.24-6.39C268.3,398.78,261,398,255.63,400.16Z",
    style: {
      opacity: 0.1,
      transformOrigin: "262.333px 403.619px"
    },
    className: "animable",
    id: "elyajnjsnlrbm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.89,417.68a2,2,0,0,0-.51.6l-1.23,2.39a1.74,1.74,0,0,1-.9.76v5.06a1.65,1.65,0,0,0,.91-.76l1.23-2.39a1.92,1.92,0,0,1,.53-.58Zm16.93-.67h0a.71.71,0,0,1-.51.66l-4.92,2a2.24,2.24,0,0,1-1.29.05v5.07a2.36,2.36,0,0,0,1.3-.05l4.92-2a.7.7,0,0,0,.51-.65Zm-32.67-2.12-4.72,1.49a2.2,2.2,0,0,1-1.19,0v5.06a2.11,2.11,0,0,0,1.19,0l4.74-1.48Zm41.45-8a2,2,0,0,1-.06.3l-.84,2.72a1.52,1.52,0,0,1-1.42,1l-5.63-.23a2.23,2.23,0,0,0-.88.18v5.07a2.2,2.2,0,0,1,.88-.18l5.62.22a1.51,1.51,0,0,0,1.42-1l.85-2.73a.84.84,0,0,0,0-.31Zm-3-8.21a.69.69,0,0,1-.21.44,1.21,1.21,0,0,1-.25.17l-3.95,2a.89.89,0,0,0-.24.18.93.93,0,0,0-.26.41.84.84,0,0,0-.06.39,1.36,1.36,0,0,0,0,.2,2.14,2.14,0,0,0,.09.27,6.91,6.91,0,0,1,.4,1.06,1.86,1.86,0,0,0,1.31,1.27l1,.16,1.7-.85a.72.72,0,0,0,.45-.63h0Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "265.92px 412.585px"
    },
    id: "elefwk0md69fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7whw0bg026n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.89,417.68a2,2,0,0,0-.51.6l-1.23,2.39a1.74,1.74,0,0,1-.9.76v5.06a1.65,1.65,0,0,0,.91-.76l1.23-2.39a1.92,1.92,0,0,1,.53-.58Zm16.93-.67h0a.71.71,0,0,1-.51.66l-4.92,2a2.24,2.24,0,0,1-1.29.05v5.07a2.36,2.36,0,0,0,1.3-.05l4.92-2a.7.7,0,0,0,.51-.65Zm-32.67-2.12-4.72,1.49a2.2,2.2,0,0,1-1.19,0v5.06a2.11,2.11,0,0,0,1.19,0l4.74-1.48Zm41.45-8a2,2,0,0,1-.06.3l-.84,2.72a1.52,1.52,0,0,1-1.42,1l-5.63-.23a2.23,2.23,0,0,0-.88.18v5.07a2.2,2.2,0,0,1,.88-.18l5.62.22a1.51,1.51,0,0,0,1.42-1l.85-2.73a.84.84,0,0,0,0-.31Zm-3-8.21a.69.69,0,0,1-.21.44,1.21,1.21,0,0,1-.25.17l-3.95,2a.89.89,0,0,0-.24.18.93.93,0,0,0-.26.41.84.84,0,0,0-.06.39,1.36,1.36,0,0,0,0,.2,2.14,2.14,0,0,0,.09.27,6.91,6.91,0,0,1,.4,1.06,1.86,1.86,0,0,0,1.31,1.27l1,.16,1.7-.85a.72.72,0,0,0,.45-.63h0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "265.92px 412.585px"
    },
    className: "animable",
    id: "elbk6sdjhptff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,395.1l-4.79,1.5a3.36,3.36,0,0,1-2-.13,25.21,25.21,0,0,0-2.57-1,1.34,1.34,0,0,1-.92-1.39l.28-2.34a1.07,1.07,0,0,0-.95-1.2L264.1,390a1.73,1.73,0,0,0-1.59.86l-1.22,2.39a2.17,2.17,0,0,1-1.6,1q-1.6.12-3.18.39a3.12,3.12,0,0,1-2-.39l-3.31-2.2a2.3,2.3,0,0,0-1.93-.2l-4.92,2a.7.7,0,0,0-.27,1.21l2.23,2.37a1,1,0,0,1-.13,1.44,13.37,13.37,0,0,0-1.35,1.2,2.74,2.74,0,0,1-1.82.78l-5.63-.23a1.51,1.51,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.35.92a1.82,1.82,0,0,1,1.31,1.25,8.51,8.51,0,0,0,.4,1.06,1.07,1.07,0,0,1-.45,1.45l-3.95,2a.66.66,0,0,0-.13,1.19l3.14,2.61a2.22,2.22,0,0,0,1.88.38l4.79-1.5a3.31,3.31,0,0,1,2,.13,25.18,25.18,0,0,0,2.57.94,1.35,1.35,0,0,1,.92,1.39l-.29,2.34a1.08,1.08,0,0,0,1,1.2l6.16.64a1.69,1.69,0,0,0,1.58-.86l1.23-2.38a2.14,2.14,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.21,3.21,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.27-1.21l-2.24-2.37a1,1,0,0,1,.14-1.44,14.48,14.48,0,0,0,1.35-1.21,2.76,2.76,0,0,1,1.82-.77l5.62.23a1.51,1.51,0,0,0,1.42-1l.86-2.72a.93.93,0,0,0-.76-1.23l-5.35-.92a1.82,1.82,0,0,1-1.3-1.25,7.35,7.35,0,0,0-.41-1.07,1.07,1.07,0,0,1,.45-1.45l3.95-2a.66.66,0,0,0,.14-1.19l-3.14-2.62A2.27,2.27,0,0,0,281.24,395.1ZM272,401.87c3.7,3.08,2.37,7.31-3,9.45s-12.67,1.37-16.37-1.71-2.38-7.31,3-9.45S268.29,398.79,272,401.87Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "262.33px 405.785px"
    },
    id: "elw9vh39m59w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz3y0klqlxgs"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55,
      transformOrigin: "262.326px 405.763px"
    },
    className: "animable",
    id: "elrmgz4k669b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.24,395.1l-4.79,1.5a3.36,3.36,0,0,1-2-.13,25.21,25.21,0,0,0-2.57-1,1.34,1.34,0,0,1-.92-1.39l.28-2.34a1.07,1.07,0,0,0-.95-1.2L264.1,390a1.73,1.73,0,0,0-1.59.86l-1.22,2.39a2.17,2.17,0,0,1-1.6,1q-1.6.12-3.18.39a3.12,3.12,0,0,1-2-.39l-3.31-2.2a2.3,2.3,0,0,0-1.93-.2l-4.92,2a.7.7,0,0,0-.27,1.21l2.23,2.37a1,1,0,0,1-.13,1.44,13.37,13.37,0,0,0-1.35,1.2,2.74,2.74,0,0,1-1.82.78l-5.63-.23a1.51,1.51,0,0,0-1.42,1l-.85,2.72a.93.93,0,0,0,.75,1.23l5.35.92a1.82,1.82,0,0,1,1.31,1.25,8.51,8.51,0,0,0,.4,1.06,1.07,1.07,0,0,1-.45,1.45l-3.95,2a.66.66,0,0,0-.13,1.19l3.14,2.61a2.22,2.22,0,0,0,1.88.38l4.79-1.5a3.31,3.31,0,0,1,2,.13,25.18,25.18,0,0,0,2.57.94,1.35,1.35,0,0,1,.92,1.39l-.29,2.34a1.08,1.08,0,0,0,1,1.2l6.16.64a1.69,1.69,0,0,0,1.58-.86l1.23-2.38a2.14,2.14,0,0,1,1.59-1,30.54,30.54,0,0,0,3.19-.4,3.21,3.21,0,0,1,2,.4l3.31,2.2a2.37,2.37,0,0,0,1.93.2l4.92-2a.7.7,0,0,0,.27-1.21l-2.24-2.37a1,1,0,0,1,.14-1.44,14.48,14.48,0,0,0,1.35-1.21,2.76,2.76,0,0,1,1.82-.77l5.62.23a1.51,1.51,0,0,0,1.42-1l.86-2.72a.93.93,0,0,0-.76-1.23l-5.35-.92a1.82,1.82,0,0,1-1.3-1.25,7.35,7.35,0,0,0-.41-1.07,1.07,1.07,0,0,1,.45-1.45l3.95-2a.66.66,0,0,0,.14-1.19l-3.14-2.62A2.27,2.27,0,0,0,281.24,395.1ZM272,401.87c3.7,3.08,2.37,7.31-3,9.45s-12.67,1.37-16.37-1.71-2.38-7.31,3-9.45S268.29,398.79,272,401.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "262.33px 405.785px"
    },
    id: "el5nb2tkfeb2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.69,422h-.17l-6.15-.64a1.49,1.49,0,0,1-1.34-1.68l.28-2.34a.9.9,0,0,0-.62-.92,26.66,26.66,0,0,1-2.61-1,3,3,0,0,0-1.74-.11l-4.79,1.5a2.68,2.68,0,0,1-2.29-.46l-3.14-2.61a1.18,1.18,0,0,1-.46-1,1.17,1.17,0,0,1,.68-.89l3.95-2a.64.64,0,0,0,.25-.88,8.12,8.12,0,0,1-.42-1.13,1.44,1.44,0,0,0-1-.95L235.8,406a1.42,1.42,0,0,1-1-.64,1.36,1.36,0,0,1-.13-1.15l.85-2.72a1.94,1.94,0,0,1,1.85-1.3l5.63.23a2.24,2.24,0,0,0,1.49-.65,13.93,13.93,0,0,1,1.39-1.24.56.56,0,0,0,.24-.41.5.5,0,0,0-.15-.39l-2.23-2.38a1.12,1.12,0,0,1,.42-1.9l4.92-2a2.77,2.77,0,0,1,2.33.24l3.31,2.2a2.66,2.66,0,0,0,1.67.33c1.05-.18,2.14-.32,3.23-.4a1.77,1.77,0,0,0,1.25-.81l1.22-2.38a2.16,2.16,0,0,1,2-1.1l6.15.65a1.5,1.5,0,0,1,1.34,1.68l-.28,2.33a.9.9,0,0,0,.62.93,26.65,26.65,0,0,1,2.61,1,3,3,0,0,0,1.73.12l4.79-1.5a2.67,2.67,0,0,1,2.29.45l3.15,2.62a1.18,1.18,0,0,1,.46,1,1.14,1.14,0,0,1-.68.88l-3.95,2a.64.64,0,0,0-.26.88,7.08,7.08,0,0,1,.43,1.13,1.42,1.42,0,0,0,1,.95l5.35.91A1.37,1.37,0,0,1,290,407.3l-.85,2.72a1.92,1.92,0,0,1-1.85,1.31l-5.63-.23a2.51,2.51,0,0,0-1.49.64,13.93,13.93,0,0,1-1.39,1.24.63.63,0,0,0-.25.42.52.52,0,0,0,.16.39l2.23,2.38a1.17,1.17,0,0,1,.34,1.07,1.22,1.22,0,0,1-.76.83l-4.92,2a2.8,2.8,0,0,1-2.33-.24l-3.31-2.2a2.69,2.69,0,0,0-1.68-.33c-1.05.18-2.13.31-3.23.4a1.72,1.72,0,0,0-1.24.8l-1.22,2.39A2.19,2.19,0,0,1,260.69,422ZM249,414.34a3.89,3.89,0,0,1,1.44.27,22.66,22.66,0,0,0,2.52.93,1.79,1.79,0,0,1,1.23,1.86l-.29,2.33a.63.63,0,0,0,.14.48.58.58,0,0,0,.44.24l6.15.65a1.3,1.3,0,0,0,1.16-.63l1.23-2.39a2.54,2.54,0,0,1,1.94-1.27c1.06-.08,2.12-.21,3.15-.39a3.53,3.53,0,0,1,2.3.46l3.31,2.2a1.9,1.9,0,0,0,1.53.16l4.92-2a.4.4,0,0,0,.24-.22.34.34,0,0,0-.13-.29L278,414.38a1.35,1.35,0,0,1-.38-1.05,1.41,1.41,0,0,1,.57-1,13.46,13.46,0,0,0,1.3-1.17,3.2,3.2,0,0,1,2.15-.9l5.62.23a1.06,1.06,0,0,0,1-.7l.86-2.72a.51.51,0,0,0-.05-.44.49.49,0,0,0-.37-.24l-5.35-.92a2.24,2.24,0,0,1-1.65-1.55,5.94,5.94,0,0,0-.38-1,1.5,1.5,0,0,1,.65-2l3.95-2c.13-.07.2-.15.21-.22s0-.17-.15-.26l-3.15-2.62a1.81,1.81,0,0,0-1.48-.29l-4.79,1.5a3.74,3.74,0,0,1-2.33-.15c-.8-.34-1.65-.65-2.53-.93a1.78,1.78,0,0,1-1.22-1.85l.29-2.34a.65.65,0,0,0-.14-.48.67.67,0,0,0-.44-.24l-6.15-.64a1.27,1.27,0,0,0-1.16.63l-1.23,2.39a2.59,2.59,0,0,1-1.94,1.27c-1.07.08-2.13.21-3.15.39a3.53,3.53,0,0,1-2.3-.46L251,392.4a1.9,1.9,0,0,0-1.53-.16l-4.92,2a.33.33,0,0,0-.24.22.36.36,0,0,0,.12.29l2.24,2.38a1.37,1.37,0,0,1,.38,1,1.41,1.41,0,0,1-.57,1,13.39,13.39,0,0,0-1.3,1.16,3.14,3.14,0,0,1-2.15.91l-5.62-.23a1.08,1.08,0,0,0-1,.7l-.85,2.72a.55.55,0,0,0,0,.44.56.56,0,0,0,.38.24l5.35.91a2.26,2.26,0,0,1,1.64,1.56,7.59,7.59,0,0,0,.38,1,1.5,1.5,0,0,1-.64,2l-4,2c-.13.06-.21.14-.22.22a.38.38,0,0,0,.16.26l3.14,2.61a1.83,1.83,0,0,0,1.48.3l4.79-1.5A2.84,2.84,0,0,1,249,414.34ZM262.37,413c-3.84,0-7.62-1.05-10-3a5.26,5.26,0,0,1-2.2-4.88c.34-2.16,2.26-4.09,5.27-5.3,5.46-2.19,13-1.39,16.8,1.78h0a5.29,5.29,0,0,1,2.2,4.88c-.34,2.16-2.26,4.09-5.27,5.3A18.72,18.72,0,0,1,262.37,413Zm0-13.57a17.82,17.82,0,0,0-6.54,1.18c-2.72,1.09-4.45,2.78-4.74,4.63a4.41,4.41,0,0,0,1.9,4.09c3.58,3,10.73,3.72,15.93,1.64,2.72-1.09,4.45-2.78,4.74-4.64a4.41,4.41,0,0,0-1.9-4.08C269.51,400.36,266,399.38,262.33,399.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "262.326px 405.763px"
    },
    id: "elsvt04wb4129",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-63",
    className: "animable",
    style: {
      transformOrigin: "79.244px 53.9532px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Gear--inject-63",
    d: "M125.64,21.74l-1.22-3.19c-.18-.47-.7-.48-1.17,0l-3.39,3.38a1.21,1.21,0,0,1-1.53.24,6,6,0,0,0-.84-.5,1.21,1.21,0,0,1-.66-1.35l1.22-5c.14-.56-.25-.93-.86-.83l-2.87.45a2.09,2.09,0,0,0-1.49,1.18l-2,5.18a3.73,3.73,0,0,1-1.43,1.58c-.54.31-1.09.68-1.65,1.08s-1.15.39-1.4,0L105,21.56c-.25-.44-.8-.39-1.23.09L100,25.93a2.35,2.35,0,0,0-.57,1.79l.77,3.3a2.86,2.86,0,0,1-.4,1.86c-.58.94-1.11,1.9-1.61,2.88a3,3,0,0,1-1.59,1.33l-2.71.84a2.32,2.32,0,0,0-1.42,1.35L90.71,45a.74.74,0,0,0,.75,1l2.29,0a.93.93,0,0,1,1,1,20.76,20.76,0,0,0-.12,2.46,3.39,3.39,0,0,1-.67,1.88L90.65,55.6a2.05,2.05,0,0,0-.39,1.77l1.23,3.19c.18.48.7.48,1.16,0l3.4-3.38A1.21,1.21,0,0,1,97.58,57a4.44,4.44,0,0,0,.84.5,1.22,1.22,0,0,1,.66,1.35l-1.22,5c-.14.56.24.93.85.84l2.88-.46A2.07,2.07,0,0,0,103.08,63l2-5.18a3.79,3.79,0,0,1,1.44-1.57,18.62,18.62,0,0,0,1.64-1.09c.54-.39,1.15-.39,1.4,0l1.36,2.33c.25.43.8.39,1.23-.1l3.76-4.27a2.31,2.31,0,0,0,.56-1.79l-.77-3.3a3,3,0,0,1,.4-1.87c.58-.94,1.12-1.9,1.61-2.87a3.07,3.07,0,0,1,1.6-1.34l2.71-.83a2.4,2.4,0,0,0,1.42-1.35l1.79-5.72a.74.74,0,0,0-.75-1l-2.3,0a.91.91,0,0,1-.94-1,20.93,20.93,0,0,0,.12-2.47,3.51,3.51,0,0,1,.66-1.88l3.27-4.21A2,2,0,0,0,125.64,21.74ZM110.57,46.37c-4.08,4.63-8.55,5.33-10,1.57s.69-10.56,4.76-15.19,8.55-5.34,10-1.58S114.64,41.74,110.57,46.37Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.955px 39.5886px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-63",
    className: "animable",
    style: {
      transformOrigin: "57.9755px 58.0026px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.89,93.43A1.51,1.51,0,0,1,43.74,93a1.48,1.48,0,0,1-.3-1.38l1.7-7a1.18,1.18,0,0,0-.64-1.28,6.85,6.85,0,0,1-1.25-.74,1.17,1.17,0,0,0-1.45.28l-4.71,4.7a1.77,1.77,0,0,1-1.58.6,1.22,1.22,0,0,1-.9-.81L32.9,82.94a3.38,3.38,0,0,1,.61-3l4.54-5.85a4.24,4.24,0,0,0,.82-2.28A30.09,30.09,0,0,1,39,68.35a.78.78,0,0,0-.17-.57.84.84,0,0,0-.62-.25l-3.19,0a1.64,1.64,0,0,1-1.34-.65,1.62,1.62,0,0,1-.2-1.46L36,57.45a3.81,3.81,0,0,1,2.32-2.22l3.77-1.16A3.76,3.76,0,0,0,44,52.48c.7-1.38,1.46-2.73,2.26-4a3.55,3.55,0,0,0,.49-2.2l-1.07-4.58a3.72,3.72,0,0,1,.9-3l5.23-5.94a1.87,1.87,0,0,1,1.54-.72,1.31,1.31,0,0,1,1,.67L56.24,36a.39.39,0,0,0,.27.19,1.29,1.29,0,0,0,.91-.28c.77-.57,1.56-1.09,2.33-1.55a4.6,4.6,0,0,0,1.77-1.92l2.74-7.2a3.45,3.45,0,0,1,2.48-2l4-.63a1.61,1.61,0,0,1,1.48.43,1.47,1.47,0,0,1,.3,1.37l-1.7,7a1.17,1.17,0,0,0,.64,1.27,8.74,8.74,0,0,1,1.25.74,1.17,1.17,0,0,0,1.45-.28l4.71-4.69a1.77,1.77,0,0,1,1.58-.6,1.21,1.21,0,0,1,.9.81l1.7,4.43a3.37,3.37,0,0,1-.61,3L77.9,41.87a4.36,4.36,0,0,0-.81,2.29,30.09,30.09,0,0,1-.16,3.49.7.7,0,0,0,.17.56.79.79,0,0,0,.62.26l3.19,0a1.56,1.56,0,0,1,1.54,2.1L80,58.54a3.84,3.84,0,0,1-2.33,2.23l-3.76,1.16A3.67,3.67,0,0,0,72,63.52c-.69,1.37-1.45,2.73-2.26,4a3.55,3.55,0,0,0-.49,2.2l1.07,4.58a3.76,3.76,0,0,1-.9,3l-5.23,5.93a1.86,1.86,0,0,1-1.54.73,1.31,1.31,0,0,1-1-.67L59.72,80a.41.41,0,0,0-.27-.19,1.23,1.23,0,0,0-.91.28c-.77.57-1.56,1.09-2.33,1.55a4.6,4.6,0,0,0-1.77,1.92l-2.75,7.2a3.43,3.43,0,0,1-2.47,2l-4,.63Zm-2.13-12a1.89,1.89,0,0,1,1.11.34,6.59,6.59,0,0,0,1.08.65,2.2,2.2,0,0,1,1.21,2.47l-1.7,7a.43.43,0,0,0,0,.41.61.61,0,0,0,.55.11l4-.63a2.37,2.37,0,0,0,1.66-1.31l2.75-7.2a5.79,5.79,0,0,1,2.21-2.45,26.48,26.48,0,0,0,2.25-1.49,2.25,2.25,0,0,1,1.74-.46,1.45,1.45,0,0,1,1,.69l1.88,3.24a.25.25,0,0,0,.21.15.84.84,0,0,0,.65-.37l5.23-5.94a2.73,2.73,0,0,0,.66-2L68.2,70a4.43,4.43,0,0,1,.62-3c.79-1.28,1.53-2.61,2.21-4a4.77,4.77,0,0,1,2.53-2.12l3.76-1.16A2.77,2.77,0,0,0,79,58.23l2.5-7.94a.52.52,0,0,0-.55-.74l-3.19,0a1.86,1.86,0,0,1-1.4-.61,1.77,1.77,0,0,1-.43-1.37A30.27,30.27,0,0,0,76,44.18a5.32,5.32,0,0,1,1-3l4.54-5.85a2.34,2.34,0,0,0,.46-2L80.37,29c-.05-.14-.12-.15-.14-.15s-.36.06-.62.31l-4.71,4.7a2.21,2.21,0,0,1-2.81.38A7.31,7.31,0,0,0,71,33.59a2.2,2.2,0,0,1-1.21-2.47l1.7-7a.49.49,0,0,0,0-.42.65.65,0,0,0-.55-.1l-4,.63a2.41,2.41,0,0,0-1.66,1.31l-2.74,7.2a5.75,5.75,0,0,1-2.22,2.45A25.4,25.4,0,0,0,58,36.71a2.28,2.28,0,0,1-1.75.47,1.45,1.45,0,0,1-1-.69l-1.88-3.24c-.07-.13-.15-.15-.21-.15a.84.84,0,0,0-.65.37l-5.23,5.94a2.73,2.73,0,0,0-.67,2L47.76,46a4.49,4.49,0,0,1-.62,3c-.78,1.27-1.53,2.6-2.21,4a4.75,4.75,0,0,1-2.53,2.12l-3.77,1.16A2.82,2.82,0,0,0,37,57.77l-2.49,7.94a.59.59,0,0,0,.05.53.62.62,0,0,0,.5.21l3.19,0a1.82,1.82,0,0,1,1.39.61,1.74,1.74,0,0,1,.44,1.37,27.84,27.84,0,0,0-.16,3.36,5.26,5.26,0,0,1-1,3l-4.54,5.84a2.4,2.4,0,0,0-.45,2L35.59,87c0,.14.11.16.14.16s.36-.06.62-.31l4.71-4.7A2.44,2.44,0,0,1,42.76,81.42Zm9.54-7.88a5.69,5.69,0,0,1-1-.09,5.3,5.3,0,0,1-4.05-3.61c-2.06-5.38,1-15.1,6.73-21.65,3.59-4.09,7.6-6.2,10.72-5.64a5.26,5.26,0,0,1,4,3.61c2.07,5.38-1,15.09-6.72,21.65l-.39-.35.39.35C58.79,71.47,55.24,73.54,52.3,73.54Zm11.33-30c-2.62,0-5.87,1.94-8.89,5.37-5.53,6.29-8.46,15.53-6.52,20.58a4.29,4.29,0,0,0,3.24,3c2.76.49,6.4-1.49,9.75-5.3h0c5.54-6.3,8.47-15.53,6.53-20.59a4.31,4.31,0,0,0-3.24-3A4.94,4.94,0,0,0,63.63,43.51Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "57.9755px 58.0026px"
    },
    id: "eleju0syvmv9u",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-63",
    className: "animable",
    style: {
      transformOrigin: "353.106px 150.546px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-marks--inject-63",
    className: "animable",
    style: {
      transformOrigin: "400.705px 245.538px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.91,280.34a12.54,12.54,0,0,1-3.51.77,9.72,9.72,0,0,1-3.39-.32,7.73,7.73,0,0,1-2.88-1.54,6.71,6.71,0,0,1-1.94-2.86,6.88,6.88,0,0,1-.5-2.7,8.44,8.44,0,0,1,.45-2.36,11.75,11.75,0,0,1,1-2.14c.38-.68.74-1.33,1.07-1.94a11.62,11.62,0,0,0,.82-1.82,3.16,3.16,0,0,0,.11-1.74,1.51,1.51,0,0,1,.07-.82.91.91,0,0,1,.54-.53l2.77-1a1.06,1.06,0,0,1,.82,0,.85.85,0,0,1,.53.59,6.7,6.7,0,0,1,.33,2.71,9.1,9.1,0,0,1-.55,2.41,13.15,13.15,0,0,1-1,2.14c-.4.68-.76,1.32-1.09,1.92a9.39,9.39,0,0,0-.72,1.73,2.48,2.48,0,0,0,.05,1.57,2.94,2.94,0,0,0,2,1.84,5.24,5.24,0,0,0,3.42-.27,5.08,5.08,0,0,0,3.39-4.79,2.48,2.48,0,0,1,.16-.74,1,1,0,0,1,.6-.46l2.94-1.1a.86.86,0,0,1,.65,0,.83.83,0,0,1,.46.49,6.12,6.12,0,0,1,.19,2.89,9.63,9.63,0,0,1-1.1,3.15,11.57,11.57,0,0,1-2.29,2.87A10.09,10.09,0,0,1,338.91,280.34Zm-9.19-20.12a1,1,0,0,1-.81,0,1,1,0,0,1-.54-.58l-1.2-3.2a1,1,0,0,1,0-.8,1,1,0,0,1,.58-.55l3.13-1.17a1,1,0,0,1,.8,0,1,1,0,0,1,.55.58l1.2,3.2a1,1,0,0,1,0,.8,1,1,0,0,1-.59.55Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "336.24px 267.49px"
    },
    id: "elkkbu7btq018",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljdr7fczcz1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "336.24px 267.49px"
    },
    className: "animable",
    id: "el1rhv4v8dsoj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.91,280.34a12.54,12.54,0,0,1-3.51.77,9.72,9.72,0,0,1-3.39-.32,7.73,7.73,0,0,1-2.88-1.54,6.71,6.71,0,0,1-1.94-2.86,6.88,6.88,0,0,1-.5-2.7,8.44,8.44,0,0,1,.45-2.36,11.75,11.75,0,0,1,1-2.14c.38-.68.74-1.33,1.07-1.94a11.62,11.62,0,0,0,.82-1.82,3.16,3.16,0,0,0,.11-1.74,1.51,1.51,0,0,1,.07-.82.91.91,0,0,1,.54-.53l2.77-1a1.06,1.06,0,0,1,.82,0,.85.85,0,0,1,.53.59,6.7,6.7,0,0,1,.33,2.71,9.1,9.1,0,0,1-.55,2.41,13.15,13.15,0,0,1-1,2.14c-.4.68-.76,1.32-1.09,1.92a9.39,9.39,0,0,0-.72,1.73,2.48,2.48,0,0,0,.05,1.57,2.94,2.94,0,0,0,2,1.84,5.24,5.24,0,0,0,3.42-.27,5.08,5.08,0,0,0,3.39-4.79,2.48,2.48,0,0,1,.16-.74,1,1,0,0,1,.6-.46l2.94-1.1a.86.86,0,0,1,.65,0,.83.83,0,0,1,.46.49,6.12,6.12,0,0,1,.19,2.89,9.63,9.63,0,0,1-1.1,3.15,11.57,11.57,0,0,1-2.29,2.87A10.09,10.09,0,0,1,338.91,280.34Zm-9.19-20.12a1,1,0,0,1-.81,0,1,1,0,0,1-.54-.58l-1.2-3.2a1,1,0,0,1,0-.8,1,1,0,0,1,.58-.55l3.13-1.17a1,1,0,0,1,.8,0,1,1,0,0,1,.55.58l1.2,3.2a1,1,0,0,1,0,.8,1,1,0,0,1-.59.55Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "336.24px 267.49px"
    },
    id: "eldhue0wvv306",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M360.5,233a1.25,1.25,0,0,1,1.73.33l2.27,3.35a1.28,1.28,0,0,1-.33,1.73l-3.28,2.22a1.28,1.28,0,0,1-1.73-.33l-2.27-3.36a1.17,1.17,0,0,1-.18-.93,1.14,1.14,0,0,1,.52-.79Zm-16.18-20.62a14.85,14.85,0,0,1,3.82-1.86,11.5,11.5,0,0,1,4-.58,9.22,9.22,0,0,1,3.74,1,8,8,0,0,1,3,2.76,8.12,8.12,0,0,1,1.32,3,9.75,9.75,0,0,1,.15,2.84,15.59,15.59,0,0,1-.51,2.74l-.71,2.53a13.43,13.43,0,0,0-.43,2.32,3.75,3.75,0,0,0,.36,2,1.9,1.9,0,0,1,.14,1,1.06,1.06,0,0,1-.48.77l-2.89,2a1.26,1.26,0,0,1-.95.2,1,1,0,0,1-.78-.53,8.07,8.07,0,0,1-1.14-3,11,11,0,0,1,0-2.92,16.69,16.69,0,0,1,.58-2.76c.27-.88.51-1.72.72-2.51a11,11,0,0,0,.35-2.19,2.91,2.91,0,0,0-.5-1.8,3.47,3.47,0,0,0-2.83-1.55,6.23,6.23,0,0,0-3.87,1.25,6,6,0,0,0-2.57,6.47,2.51,2.51,0,0,1,0,.9,1.19,1.19,0,0,1-.56.69l-3.09,2.09a1,1,0,0,1-.74.17,1,1,0,0,1-.66-.44,7.13,7.13,0,0,1-1-3.28,11.16,11.16,0,0,1,.39-3.94,13.63,13.63,0,0,1,1.84-3.94A12,12,0,0,1,344.32,212.35Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "351.729px 225.383px"
    },
    id: "elxu9xf29ofis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwppa4xno0qk"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "351.729px 225.383px"
    },
    className: "animable",
    id: "eldw9z7a5gjfs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.5,233a1.25,1.25,0,0,1,1.73.33l2.27,3.35a1.28,1.28,0,0,1-.33,1.73l-3.28,2.22a1.28,1.28,0,0,1-1.73-.33l-2.27-3.36a1.17,1.17,0,0,1-.18-.93,1.14,1.14,0,0,1,.52-.79Zm-16.18-20.62a14.85,14.85,0,0,1,3.82-1.86,11.5,11.5,0,0,1,4-.58,9.22,9.22,0,0,1,3.74,1,8,8,0,0,1,3,2.76,8.12,8.12,0,0,1,1.32,3,9.75,9.75,0,0,1,.15,2.84,15.59,15.59,0,0,1-.51,2.74l-.71,2.53a13.43,13.43,0,0,0-.43,2.32,3.75,3.75,0,0,0,.36,2,1.9,1.9,0,0,1,.14,1,1.06,1.06,0,0,1-.48.77l-2.89,2a1.26,1.26,0,0,1-.95.2,1,1,0,0,1-.78-.53,8.07,8.07,0,0,1-1.14-3,11,11,0,0,1,0-2.92,16.69,16.69,0,0,1,.58-2.76c.27-.88.51-1.72.72-2.51a11,11,0,0,0,.35-2.19,2.91,2.91,0,0,0-.5-1.8,3.47,3.47,0,0,0-2.83-1.55,6.23,6.23,0,0,0-3.87,1.25,6,6,0,0,0-2.57,6.47,2.51,2.51,0,0,1,0,.9,1.19,1.19,0,0,1-.56.69l-3.09,2.09a1,1,0,0,1-.74.17,1,1,0,0,1-.66-.44,7.13,7.13,0,0,1-1-3.28,11.16,11.16,0,0,1,.39-3.94,13.63,13.63,0,0,1,1.84-3.94A12,12,0,0,1,344.32,212.35Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "351.729px 225.383px"
    },
    id: "elmz3048jdxhd",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M458.38,268.05a1.26,1.26,0,0,1,.63,1.64l-1.66,3.7a1.25,1.25,0,0,1-1.65.62l-3.61-1.62a1.18,1.18,0,0,1-.64-.69,1.16,1.16,0,0,1,0-.95l1.66-3.7a1.21,1.21,0,0,1,.69-.64,1.16,1.16,0,0,1,.95,0Zm9-24.6a15,15,0,0,1,3.59,2.27,11.49,11.49,0,0,1,2.59,3.11,8.93,8.93,0,0,1,1.14,3.69,7.94,7.94,0,0,1-.75,4,8.12,8.12,0,0,1-1.83,2.68,9.49,9.49,0,0,1-2.35,1.62,16.34,16.34,0,0,1-2.59,1l-2.53.73a12.62,12.62,0,0,0-2.19.85,3.78,3.78,0,0,0-1.55,1.37,1.72,1.72,0,0,1-.74.63,1,1,0,0,1-.91,0L456.11,264a1.25,1.25,0,0,1-.67-.7,1,1,0,0,1,.05-.94,7.88,7.88,0,0,1,2-2.56,11.06,11.06,0,0,1,2.47-1.57,15.56,15.56,0,0,1,2.65-1c.9-.24,1.73-.48,2.51-.71a10.28,10.28,0,0,0,2-.85,3,3,0,0,0,1.27-1.37,3.49,3.49,0,0,0-.16-3.23,6.26,6.26,0,0,0-3.11-2.63q-3.57-1.61-6.85,1.21a2.63,2.63,0,0,1-.75.49,1.15,1.15,0,0,1-.88-.11l-3.4-1.53a1,1,0,0,1-.54-.55.92.92,0,0,1,0-.79,7.2,7.2,0,0,1,2.25-2.6,11.29,11.29,0,0,1,3.55-1.73,13.78,13.78,0,0,1,4.32-.51A11.92,11.92,0,0,1,467.42,243.45Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "463.035px 258.214px"
    },
    id: "elbri62fx9pz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkh4tys3h1c"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "463.035px 258.214px"
    },
    className: "animable",
    id: "el5olqqaer1bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.38,268.05a1.26,1.26,0,0,1,.63,1.64l-1.66,3.7a1.25,1.25,0,0,1-1.65.62l-3.61-1.62a1.18,1.18,0,0,1-.64-.69,1.16,1.16,0,0,1,0-.95l1.66-3.7a1.21,1.21,0,0,1,.69-.64,1.16,1.16,0,0,1,.95,0Zm9-24.6a15,15,0,0,1,3.59,2.27,11.49,11.49,0,0,1,2.59,3.11,8.93,8.93,0,0,1,1.14,3.69,7.94,7.94,0,0,1-.75,4,8.12,8.12,0,0,1-1.83,2.68,9.49,9.49,0,0,1-2.35,1.62,16.34,16.34,0,0,1-2.59,1l-2.53.73a12.62,12.62,0,0,0-2.19.85,3.78,3.78,0,0,0-1.55,1.37,1.72,1.72,0,0,1-.74.63,1,1,0,0,1-.91,0L456.11,264a1.25,1.25,0,0,1-.67-.7,1,1,0,0,1,.05-.94,7.88,7.88,0,0,1,2-2.56,11.06,11.06,0,0,1,2.47-1.57,15.56,15.56,0,0,1,2.65-1c.9-.24,1.73-.48,2.51-.71a10.28,10.28,0,0,0,2-.85,3,3,0,0,0,1.27-1.37,3.49,3.49,0,0,0-.16-3.23,6.26,6.26,0,0,0-3.11-2.63q-3.57-1.61-6.85,1.21a2.63,2.63,0,0,1-.75.49,1.15,1.15,0,0,1-.88-.11l-3.4-1.53a1,1,0,0,1-.54-.55.92.92,0,0,1,0-.79,7.2,7.2,0,0,1,2.25-2.6,11.29,11.29,0,0,1,3.55-1.73,13.78,13.78,0,0,1,4.32-.51A11.92,11.92,0,0,1,467.42,243.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "463.035px 258.214px"
    },
    id: "elln50yn4if4",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--message-icon--inject-63",
    className: "animable",
    style: {
      transformOrigin: "271.385px 50.9929px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Message--inject-63",
    className: "animable",
    style: {
      transformOrigin: "252.885px 52.4329px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--message--inject-63",
    d: "M271,23.22,234.77,44.13a7.85,7.85,0,0,0-3.28,6.27V79.16c0,2.42,1.47,3.53,3.28,2.48L271,60.74a7.88,7.88,0,0,0,3.28-6.27V25.7C274.26,23.29,272.79,22.18,271,23.22ZM260.23,48.13l12.71-23.07a2.63,2.63,0,0,1,.27,1.25V53.67Zm-25.46-2.6L271,24.62a1.54,1.54,0,0,1,1.26-.21l-18,32.66c-.77,1.41-2,2.1-2.75,1.59l-18-11.89A4,4,0,0,1,234.77,45.53Zm-2,2.69,12.7,8.4-13,20.54V49.79A5.15,5.15,0,0,1,232.82,48.22ZM271,59.34l-36.21,20.9c-1.15.67-2.08,0-2.21-1.37L246.3,57.14l4.49,3a1.93,1.93,0,0,0,2.09-.12A6,6,0,0,0,255,57.69l4.48-8.14,13.74,5.86A5.3,5.3,0,0,1,271,59.34Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "252.885px 52.4329px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--message--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,23.22,234.77,44.13a7.85,7.85,0,0,0-3.28,6.27V79.16c0,2.42,1.47,3.53,3.28,2.48L271,60.74a7.88,7.88,0,0,0,3.28-6.27V25.7C274.26,23.29,272.79,22.18,271,23.22ZM260.23,48.13l12.71-23.07a2.63,2.63,0,0,1,.27,1.25V53.67Zm-25.46-2.6L271,24.62a1.54,1.54,0,0,1,1.26-.21l-18,32.66c-.77,1.41-2,2.1-2.75,1.59l-18-11.89A4,4,0,0,1,234.77,45.53Zm-2,2.69,12.7,8.4-13,20.54V49.79A5.15,5.15,0,0,1,232.82,48.22ZM271,59.34l-36.21,20.9c-1.15.67-2.08,0-2.21-1.37L246.3,57.14l4.49,3a1.93,1.93,0,0,0,2.09-.12A6,6,0,0,0,255,57.69l4.48-8.14,13.74,5.86A5.3,5.3,0,0,1,271,59.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "252.885px 52.4329px"
    },
    className: "animable",
    id: "el8lzrmb56ysq"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--message--inject-63",
    className: "animable",
    style: {
      transformOrigin: "289.89px 49.5529px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--message--inject-63",
    d: "M308,20.34,277,38.22v1.4l31-17.88a1.52,1.52,0,0,1,1.25-.21l-18,32.66c-.77,1.41-2,2.11-2.75,1.59L277,48.19v1.92l5.5,3.63-13,20.54V64.75l-1,.61V76.28c0,2.42,1.47,3.53,3.28,2.48L308,57.86a7.88,7.88,0,0,0,3.28-6.27V22.82C311.24,20.41,309.77,19.3,308,20.34Zm0,36.12L271.75,77.37c-1.15.66-2.09,0-2.21-1.38l13.74-21.73,4.48,3a1.93,1.93,0,0,0,2.09-.12,5.81,5.81,0,0,0,2.09-2.29l4.49-8.14,13.74,5.86A5.33,5.33,0,0,1,308,56.46Zm2.23-5.67-13-5.54,12.7-23.07a2.63,2.63,0,0,1,.28,1.25Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "289.89px 49.5529px"
    },
    className: "animable"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBot);
export default __webpack_public_path__ + "static/media/chatBot.9dd3b064cf554fb61095543781d9338a.svg";
export { ForwardRef as ReactComponent };